
import React, { useLayoutEffect, useState, useRef,useEffect } from 'react';
import {API_BASE_URL} from '../../../../config';
import { useHistory,useLocation  } from 'react-router-dom/cjs/react-router-dom';
import InputLabel from '@material-ui/core/InputLabel';
import Box from '@material-ui/core/Box';
import { Checkbox ,ListItemText  ,OutlinedInput } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl'; 
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import SelectBox from 'devextreme-react/select-box';
import TextField from '@material-ui/core/TextField';
import Filezone,{ Filezonefile } from './Filezone';
import MapModal from "./MapModal";

import Autocomplete from "@material-ui/lab/Autocomplete";
import { Modal, Button,Dropdown } from "react-bootstrap";
import RenewLeaseModal from './RenewLeaseModal';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import axios from "axios";
import 'devextreme/data/odata/store';
import "devextreme/dist/css/dx.material.orange.light.css"
import PerfectScrollbar from 'react-perfect-scrollbar'
import Swal from 'sweetalert2';
import { TagBox } from 'devextreme-react';

import Gallery from 'devextreme-react/gallery';
import DataGrid, {
    Column,
    Pager,
    Paging,
    SearchPanel,
    GroupPanel,
    Lookup,
    Export,
    ColumnFixing,
    Editing,
    Selection,
    Scrolling,
    Toolbar,
    Item
} from 'devextreme-react/data-grid';
import {
    EmptyItem
} from 'devextreme-react/form';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver-es';
import Geocode from "react-geocode";
import MapContainer2 from "./Map2"
import "./map.css";
import 'react-dropzone-uploader/dist/styles.css'
import Dropzone from 'react-dropzone-uploader'

import { jsPDF } from 'jspdf';
import { exportDataGrid as exportDataGridToPdf } from 'devextreme/pdf_exporter';
import { exportDataGrid } from 'devextreme/excel_exporter';
import moment from 'moment';

var surplusid = 0;
const generateColor = () => {
    let randomColorString = "#";
    const arrayOfColorFunctions = "0123456789abcdef";
    for (let x = 0; x < 6; x++) {
      let index = Math.floor(Math.random() * 16);
      let value = arrayOfColorFunctions[index];
  
      randomColorString += value;
    }
    return randomColorString;
  };
const SuitesEditor = ({ data, setValue }) => {
  const [suitesOptions, setSuitesOptions] = React.useState([]);
  const [selectedIds, setSelectedIds] = React.useState([]);

  // Fetch suites for building
  React.useEffect(() => {
    if (data.buildingid) {
      fetch(`${API_BASE_URL}api/buildingsuites/${data.buildingid}`)
        .then((res) => res.json())
        .then((suites) => {
          setSuitesOptions(suites || []);

          // Set selectedIds after suitesOptions loaded
          const ids = Array.isArray(data.suites)
            ? data.suites.filter(s => s?.suiteid).map(s => s.suiteid)
            : [];
          
          // Make sure the types match valueExpr
          const validIds = ids.filter(id => suites.some(s => s.suiteid === id));
          setSelectedIds(validIds);
        });
    }
  }, [data.buildingid, data.suites]);

  return (
    <TagBox
      dataSource={suitesOptions}
      valueExpr="suiteid"
      displayExpr="suitenumber"
      value={selectedIds}
      showSelectionControls
      applyValueMode="useButtons"
      onValueChanged={(e) => {
        setSelectedIds(e.value);
        const selected = suitesOptions.filter(opt =>
          e.value.includes(opt.suiteid)
        );
        setValue(selected); // save selected suites to parent
      }}
    />
  );
};




const LeaseDetails = () => {
    const gridRef = useRef(null);
    const editLeaseById = (leaseid) => {
        const grid = gridRef.current?.instance;
        if (grid) {
        const rowIndex = grid.getRowIndexByKey(leaseid);
        if (rowIndex >= 0) {
            modClose();
            grid.editRow(rowIndex); // ✅ this opens that row in edit mode
        } else {
            console.warn("Row not found for leaseid:", leaseid);
        }
        }
    };

    function formatWithTwoDecimals(value) {
        return Number(value).toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    }


    const selFY = moment().month() >= 6 ? moment().year() + 1 : moment().year();
    const [currentFY, setTargetedFY] = useState(selFY)

    const fyoptions = [];
    const [collapsedOnce, setCollapsedOnce] = useState(false);
    
    const currentyear =new Date().getFullYear()
    
    // const navigate = useNavigate();
    let history = useHistory();
    
    const { search } = useLocation()

    for (let year = currentyear-1; year <= currentyear+5; year++) {
        fyoptions.push(year);
      }

    // Build dropdown options (array of objects with value + text)
    const listedyears = fyoptions.map((year) => ({
        value: year,
        text: `FY ${year.toString().slice(-2)}`
    }));
    
    // Handle SelectBox change
    const setTarget = (e) => {
        const fy = e.value; // DevExtreme returns object with "value"
        setTargetedFY(fy);
    };
    const [fyear, setfyear] = useState(currentyear);
    
    const handlefy = (e)=> {

        // console.log(e.target.value)
        history.push("/lease-details?fy="+e.target.value);

    }
    const [formMode, setFormMode] = useState(null); // "add" | "edit"
    const [showModal, setShowModal] = useState(false);
    const [showDuplicateModal, setShowDuplicateModal] = useState(false);
    const [selectedLease, setSelectedLease] = useState(null);

    const [showModalh, setShowModalh] = useState(false);    
    const [Sellid, setSellid] = useState(null);      
    const selHandleRef = React.useRef(null);
    
    const [pendingChange, setPendingChange] = useState(null);

    const handleDuplicateLease = (lease) => {
        setSelectedLease(lease);
        setShowModal(true);
    };
    const openDuplicateModal  = (lease) => {
        setSelectedLease(lease);
        setShowDuplicateModal(true);
    };
    const handleDuplicateSubmit = async () => {
        setShowDuplicateModal(false);

        try {
            const res = await fetch(`${API_BASE_URL}api/duplicateLease`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                leaseid: selectedLease.leaseid, // only pass leaseid
            }),
            });

            const result = await res.json();

            if (res.ok) {
            Swal.fire('Done', 'Lease duplicated successfully!', 'success');

            // Refresh lease list
            axios
                .get(`${API_BASE_URL}api/leaselist`, {
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Access-Control-Allow-Methods': 'GET, POST, PUT, OPTIONS',
                },
                })
                .then((resp) => {
                if (resp.status === 200) {
                    setdataList(resp.data);
                }
                });
            } else {
            Swal.fire('Error', result.message || 'Failed to duplicate lease', 'error');
            }
        } catch (err) {
            console.error(err);
            Swal.fire('Error', 'Something went wrong while duplicating lease', 'error');
        }
        };


    const handleRenewSubmit = async ({ commenceDate, expireDate }) => {
    setShowModal(false);

    // Do your API call to create new lease (renewed version)
    try {
      const res = await fetch(`${API_BASE_URL}api/leaserenew`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          leaseid: selectedLease.leaseid,
          commence_date: commenceDate,
          expiration_date: expireDate,
        }),
      });

      const result = await res.json();
      
            Swal.fire(
                        'Done ',
                        'Lease renewed successfully!',
                        'success'
                    )
        axios.get(`${API_BASE_URL}api/leaselist`,
        {
            headers:{
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Methods': 'GET, POST, PUT, OPTIONS'
            }
        }).then(resp => {
            if (resp.status === 200) {
                setdataList(resp.data);
            }
        })
      // reload lease list etc.
    } catch (err) {
      console.error(err);
      alert('Failed to renew lease');
    }
  };

 



    const optionYesNo = [{
        ID: 'Y',
        Name: 'Yes',
      }, {
        ID: 'N',
        Name: 'No',
      }]
    const [internalStartDates, setInternalStartDates] = useState(['']);
    const [internalStopDates, setInternalStopDates] = useState(['']);
    const [key, setKey] = useState('2025');
    const [commentModal, setCommentModal]  = useState(false)
    const [dataList, setdataList] = useState([]);
    const [mapModal, setMapModal] = useState(false);
    
    const [location, setLocation] = useState({lat:53.9171, lng:122.74, name:'My Location'})
    const [Comments, setComment] = useState([])
    const [CommetPID, setCommentPID] = useState(0)
    const newComment = useRef(null)
    var lat = 53.9171, lng=122.74;
    const leaseTypes = [
        { value: 1, name: "In-Lease" },
        { value: 2, name: "Out-Lease" },
        { value: 3, name: "License" }
    ]
    const exportFormats = ['xlsx'];
    const convert_date = (date)=> {
        if(date != null && date != "0000-00-00"){            
            return moment(date).format('MM/DD/YYYY')
        }else{
            return '';
        }
    }
    const [show, setShow] = useState(false);
    const [modalShow, setModalShow] = useState(false);    
    const [leaseVersions, setLeaseVersions] = useState([]); // all versions
    const [selectedLeaseId, setSelectedLeaseId] = useState(null);
    const [prID, setPrID] = useState("");

    const handleClose = () => setShow(false);
    const modClose = () => setModalShow(false);
    const modShow = () => setModalShow(true);
    const [myOptions, setMyOptions] = useState([]);

    const [imgShow, setImgShow] = useState(false);     
    const imgmodClose = () => {
        
        setImgShow(false)
        setViewer('Loading....');
        setGalleryTitle('')
    };     
    const [viewer,setViewer] = useState('Loading....')     
    const [imgGallery, setGallery] = useState([]);  
    const [galleryTitle, setGalleryTitle] = useState([]);
    const [dropShow, setDropShow] = useState(false);     
    const dropClose = () => setDropShow(false);
    
    const [expandImg, setExpandImg] = useState(""); 
    const [expandShow, setExpandShow] = useState('none'); 
    const expandClose = () => setExpandShow('none');

    
    const getUploadParams = ({ file, meta }) => {
        const body = new FormData()
        body.append('file', file)
        body.append('propertyid',prID)
        return { url: `${API_BASE_URL}api/primgupload`, body }
    }


    const getUploadFiles = ({ file, meta }) => {
        const body = new FormData()
        body.append('file', file)
        body.append('propertyid',prID)
        return { url: `${API_BASE_URL}api/prfileupload`, body }
    }

    const fetchLeaseVersions = async (leaseCode) => {
        setLeaseVersions([])
        try {
            const res = await axios.get(`${API_BASE_URL}api/leaseversions/${leaseCode}`);
            setLeaseVersions(res.data);

            // Select latest lease by default
            if (res.data.length > 0) {
                setSelectedLeaseId(res.data[0].leaseid);
                // fetchLeaseDetails(res.data[0].leaseid);
            }
        } catch (err) {
            console.error("Failed to fetch lease versions", err);
        }
    };
    const cleanLeaseData = (data) => {
        return {
            ...data,
            fy25: [],
            fy24: [],
            fy23: [],
            annualrentbase1: null,
            annualrentbase2: null,
            monthlyrentbase1: null,
            monthlyrentbase2: null,
            psf1: null,
            psf2: null
        };
    };
    const fetchLeaseDetails = async (leaseid) => {
        try {
            const res = await axios.get(`${API_BASE_URL}api/lease/${leaseid}`);
            setDetail(cleanLeaseData(res.data));
            console.log(res.data);
        } catch (err) {
            console.error("Failed to fetch lease details", err);
        }
    };
    const [tenants, setTenants] = useState([]);
    const [landlords, setLandlords] = useState([]);
    const [usersData, setusersData] = useState({
    tenant_id: "",
    landlord_id: "",
    tenantManual: false,
    landlordManual: false,
    // other lease fields...
    });

    useEffect(() => {
        // Fetch tenants
        fetch(`${API_BASE_URL}api/tenants`)
            .then((res) => res.json())
            .then((data) => setTenants(data))
            .catch((err) => console.error("Failed to fetch tenants", err));

        // Fetch landlords
        fetch(`${API_BASE_URL}api/landlords`)
            .then((res) => res.json())
            .then((data) => setLandlords(data))
            .catch((err) => console.error("Failed to fetch landlords", err));
    }, []);





    const getImg = (data) => {
        fetch(`${API_BASE_URL}api/property/`+data)
            .then((response) => {
                return response.json();
            })
            .then((res) => {
                setGalleryTitle(res.propertyaddress)                
                
                if(res.image==null){                    
                    setGallery([])
                    setViewer("No Images")
                }else{
                    const imgage =res.image.split(',') 
                    setGallery(imgage)
                    setViewer(<Gallery
                    id="gallery"
                    dataSource={imgage}
                    height={540}
                    slideshowDelay={0}
                    showNavButtons={true}
                    showIndicator={false}
                    onItemClick={(e) => {
                        setExpandImg(e.itemData)
                        setExpandShow('block')
                        }}  />)
                }
                
            });
        setImgShow(true)      

    };
    const imgDel =(img,id)=>{
        axios.post(`${API_BASE_URL}api/primgdel`, { propertyid: id, file: img })
                .then(resp => {
                    // no nothing
                    Swal.fire("Deleted", "The Image has been removed from the lease property", "success", {
                                button: "OK",
                                });
                    getFiles(id)
                });
            
    }
    const fileDel =(file,id)=>{
        axios.post(`${API_BASE_URL}api/prfiledel`, { propertyid: id, file: file })
                .then(resp => {
                    // no nothing 
                    Swal.fire("Deleted", "The file has been removed from the lease property", "success", {
                                button: "OK",
                                });
                    getFiles(id)
                });   
    }

    const getFiles = (data) => {
        fetch(`${API_BASE_URL}api/property/`+data)
            .then((response) => {
                return response.json();
            })
            .then((res) => {
                setGalleryTitle(res.propertyaddress)                
                
                if(res.image==null){                    
                    var images=(<tr><td colSpan={3}>No Images</td></tr>)
                }else{
                    let i=0;
                    const imagelist =res.image.split(',') 
                    var images= imagelist.map((image) =>{
                        const imgName = image.split('/').pop();
                        return(
                            <tr>
                                <td className='file-td'><span>{imgName}</span></td>                            
                                <td><a className="vie-buttons" target="_blank" onClick={() => {
                                    setExpandImg(image)
                                    setExpandShow('block')
                                    }} ><i className='fa fa-eye'></i> View</a></td>
                                <td><a className="delete-buttons" style={{cursor:'pointer'}} href={void(0)} onClick={() => {
                                imgDel(image,data);
                                }} ><i className='fa fa-trash'></i> Delete</a></td>
                            </tr> 

                        );
                    });                              
                }
                if(res.files==null){                    
                    
                    var files=(<tr><td colSpan={3}>No Files</td></tr>)
                }else{
                    let i=0;
                    const fileslist =res.files.split(',') 
                    var  files= fileslist.map((file) =>{
                        const fileName = file.split('/').pop();
                        return (
                                <tr>
                                    <td className='file-td'><span>{fileName}</span></td>                            
                                    <td><a className="vie-buttons" href={file} target="_blank"><i className='fa fa-eye'></i> View</a></td>
                                    <td><a className="delete-buttons" style={{cursor:'pointer'}}  onClick={() => {
                                        fileDel(file,data);
                                        }} ><i className='fa fa-trash'></i> Delete</a></td>
                                </tr> 
                                ) ;
                            });                               
                }
                setViewer(<div>
                    <ul >
                        <li className="main-files">
                            <div className='table responsive'>
                                <table className='aprl table table-bordered table-striped'>
                                    <thead><tr><th className="" colSpan={3}>Images :</th></tr></thead>
                                    {images}
                                </table>
                            </div>
                        </li>
                        <li className="main-files">
                            <div className='table responsive'>
                                <table className='aprl table table-bordered table-striped'>
                                    <thead><tr><th className="" colSpan={3}>Files :</th></tr></thead>
                                    
                                    {files}
                                </table>
                            </div>
                        </li>
                    </ul>
                </div>)
                
            });
            
        setImgShow(true)      

    };
       
    const [infoDetail, setDetail] = useState({
       fy25:[],
       fy24:[], 
       fy23:[], 
    });
    function endOfMonth(date, monthsToAdd) {
        let d = new Date(date);
        d.setMonth(d.getMonth() + monthsToAdd, 0); // Set to last day of the target month
        return d;
    }

    function calculateValue(E18, V18, F18, S18, D18, J18) {
        J18=J18/100
        
    
        let eom = endOfMonth(E18, V18 - 1); // Equivalent to EOMONTH(E18, V18-1)
    
        if (eom > new Date(F18)) {
            return 0;
        } else {
            return (S18 * D18) * Math.pow(1 + J18, V18 - 1);
        }
    }
    function chooseByMonth(dateString) {
        const months = [7, 8, 9, 10, 11, 12, 1, 2, 3, 4, 5, 6]; // Values to choose from
        const monthIndex = new Date(dateString).getMonth(); // 0-based (January = 0, February = 1, etc.)
        return months[monthIndex]; // Selects the corresponding value
    }
    const customizeCurrencyText = (e) => {
        if (e.value == null) return '';
        return `$${Number(e.value).toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        })}`;
    };

    const getFYBaseRentValues = (targetFY, infoDetail) => {
        const basePSF = infoDetail.rentpersf ?? 0;
        const sqft = infoDetail.areasf ?? 0;
        const escalationPercent = infoDetail.escalationpercent ?? 0;

        const commence = moment(infoDetail.rental_commence_date || infoDetail.commence_date);

        // Use leasterminateddate if it exists and is earlier than expiration_date
        let expire = moment(infoDetail.expiration_date);
        if (infoDetail.leasterminateddate && moment(infoDetail.leasterminateddate).isBefore(expire)) {
            expire = moment(infoDetail.leasterminateddate);
        }

        const abatementStart = infoDetail.abatement_start ? moment(infoDetail.abatement_start) : null;
        const abatementEnd = infoDetail.abatement_end ? moment(infoDetail.abatement_end) : null;

        const currentStart = commence.clone();
        const stopDates = (infoDetail.internal_stop_dates ?? []).map(date => moment(date)).sort((a, b) => a - b);

        let psf = basePSF;
        let start = currentStart.clone();

        const fyStart = moment.utc(`${targetFY - 1}-07-01`);
        const fyEnd = moment.utc(`${targetFY}-06-30`);

        const results = [];

        while (start.isSameOrBefore(expire)) {
            let end = start.clone().add(1, 'year').subtract(1, 'day');
            const stop = stopDates.find(d => d.isSameOrAfter(start) && d.isSameOrBefore(end));
            if (stop) end = stop.clone();
            if (end.isAfter(expire)) end = expire.clone();

            const overlapStart = moment.max(start, fyStart);
            const overlapEnd = moment.min(end, fyEnd);

            if (overlapStart.isSameOrBefore(overlapEnd)) {
                const months = overlapEnd.diff(overlapStart, 'months') + (overlapEnd.date() >= overlapStart.date() ? 1 : 0);
                const monthlyBase = parseFloat(((psf * sqft) / 12).toFixed(4));

                let monthsAbated = 0;
                if (abatementStart && abatementEnd) {
                    const abateStartInRange = moment.max(overlapStart, abatementStart);
                    const abateEndInRange = moment.min(overlapEnd, abatementEnd);
                    if (abateStartInRange.isSameOrBefore(abateEndInRange)) {
                        monthsAbated = abateEndInRange.diff(abateStartInRange, 'months') + 1;
                    }
                }

                const monthlyAbatement = monthsAbated > 0 ? -monthlyBase : 0;
                const annualAbatement = monthsAbated > 0 ? monthlyAbatement * monthsAbated : 0;

                results.push({
                    months,
                    psf: parseFloat((Math.floor(psf * 100) / 100).toFixed(2)),
                    monthlyBase,
                    monthlyAbatement,
                    annualAbatement
                });
            }

            const isFullYear = end.diff(start, 'months') >= 11;
            const wasStoppedEarly = stop && stop.isSame(end);
            if (isFullYear || wasStoppedEarly) {
                psf *= 1 + escalationPercent / 100;
            }

            start = end.clone().add(1, 'day');
            if (start.isAfter(expire)) break;
        }

        const final = {};
        results.forEach((item, index) => {
            const suffix = index + 1;
            final[`months${suffix}`] = item.months;
            final[`psf${suffix}`] = item.psf;
            final[`monthlyBase${suffix}`] = item.monthlyBase;
            if (item.monthlyAbatement !== 0) {
                final[`monthlyAbatement${suffix}`] = item.monthlyAbatement;
                final[`annualAbatement${suffix}`] = item.annualAbatement;
            }
        });
        if (final.months1 && final.months2 && (final.months1 + final.months2 > 12)) {
            final.months2 = final.months2 - 1;
        }
        return final;
    };




    // setDetail(infoLease)

    const getInfo = (data) => {
        let addrs = data.propertyaddress;
        if(data.city){
            addrs =addrs+','+data.city;
        }
        if(data.state){
            addrs =addrs+','+data.state;
        }

        data.annualrentbase1 = null
        data.annualrentbase2 = null
        data.monthlyrentbase1 = null
        data.monthlyrentbase2 = null
        data.psf1 = null
        data.psf2 = null
        data.fy24 = []
        data.fy23 = []
        Geocode.setApiKey("AIzaSyBxLd_UmZ_U0NLhQvqTLd-Ek_k3SbOkykI")
                Geocode.setLanguage("en");
                Geocode.setLocationType("ROOFTOP");
                
                Geocode.fromAddress(addrs).then(
                (response) => {
                    // console.log(response.results[0].geometry.location)
                    lat = response.results[0].geometry.location.lat;
                    lng = response.results[0].geometry.location.lng
                    setLocation({lat:lat, lng:lng, name: data.value});
                    
                })
        
        // let leasefy = []

             
                setDetail(data)
                setModalShow(true)                 
                console.log(data.leasecode) 
                fetchLeaseVersions(data.leasecode)     

    };
    const handleSubmit = (event) => {
        event.preventDefault();

        const formData = new FormData(event.target);
        const payload = {};

        // Collect all form fields dynamically
        for (let [key, value] of formData.entries()) {
            payload[key] = value;
        }

        // Merge tenant and landlord details from state
        payload.tenant_id = usersData.tenant_id || "";
        payload.tenantManual = usersData.tenantManual || false;
        payload.tenantcontactname = usersData.tenantcontactname || "";
        payload.tenantcontactphone1 = usersData.tenantcontactphone1 || "";
        payload.tenantcontactphone2 = usersData.tenantcontactphone2 || "";
        payload.tenantcontactemail1 = usersData.tenantcontactemail1 || "";
        payload.tenantcontactemail2 = usersData.tenantcontactemail2 || "";

        payload.landlord_id = usersData.landlord_id || "";
        payload.landlordManual = usersData.landlordManual || false;
        payload.landlordname = usersData.landlordname || "";
        payload.landlordphone1 = usersData.landlordphone1 || "";
        payload.landlordphone2 = usersData.landlordphone2 || "";
        payload.landlordemail1 = usersData.landlordemail1 || "";
        payload.landlordemail2 = usersData.landlordemail2 || "";


        // Include internal start/stop dates from state
        payload.internal_start_dates = internalStartDates.filter(d => d);
        payload.internal_stop_dates = internalStopDates.filter(d => d);

        axios.post(`${API_BASE_URL}api/leaseadd`, payload)
            .then(() => {
                setShow(false);
                return axios.get(`${API_BASE_URL}api/leaselist`, {
                    headers: {
                        'Access-Control-Allow-Origin': '*',
                        'Access-Control-Allow-Methods': 'GET, POST, PUT, OPTIONS',
                    }
                });
            })
            .then(resp => {
                if (resp.status === 200) setdataList(resp.data);
                Swal.fire('Done', 'Lease added Successfully!', 'success');
            })
            .catch(error => {
                console.error(error);
                Swal.fire('Failed', 'Lease Insert Error', 'error');
            });
    };

   


    const SaveComment = (value, ID)=> {
    
        console.log(`Surplus ID ${CommetPID} - Comment: ${value}`)
        axios.post(`${API_BASE_URL}api/leasecomment/${CommetPID}`, { comment: value, commentid:0},
        {
            headers:{
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Methods': 'GET, POST, PUT, OPTIONS'
            }
        }).then(resp =>{
            axios.get(`${API_BASE_URL}api/leaselist`,
            {
                headers:{
                    'Access-Control-Allow-Origin': '*',
                    'Access-Control-Allow-Methods': 'GET, POST, PUT, OPTIONS'
                }
            }).then(resp => {
                if (resp.status === 200) {
                    setdataList(resp.data);
                    axios.get(`${API_BASE_URL}api/leasecomment/${CommetPID}`, (err, result)=>{
                        const _Comments = result.data;
                        console.log("success")
                        console.log(_Comments)
                        setComment(_Comments)
                    }).then(result => {
                        const _Comments = result.data;
                        console.log("success")
                        console.log(_Comments)
                        setComment(_Comments)
                    })
                }
            })
            
        })
    }
    useLayoutEffect(() => {
        console.log('Test');
        axios.get(`${API_BASE_URL}api/leaselist`,{
        
                headers:{
                    'Access-Control-Allow-Origin': '*',
                    'Access-Control-Allow-Methods': 'GET, POST, PUT, OPTIONS'
                }
            }
        ).then(resp => {
            if (resp.status === 200) {
                // resp.data.forEach((itm) => {
                //     itm.leasetype = leaseTypes.filter(v => v.value === itm.leasetype)[0].name
                //     //itm.commdate = itm.comdate ? intl.parseDate(itm.comdate) : null 
                //     //itm.expdate = itm.expdate ? intl.parseDate(itm.expdate) : null
                //     itm.address1 = `${itm.address1} ${itm.address2} ${itm.city} ${itm.state} ${itm.zip ? itm.zip : ''}`
                // })
                setdataList(resp.data)
                //setDataResult(resp.data, dataState);
            }
        })
        fetch(`${API_BASE_URL}api/propertylease`)
            .then((response) => {
            return response.json();
            })
            .then((res) => {
            console.log(res);
            for (var i = 0; i < res.length; i++) {

                
                myOptions.push(res[i].propertyaddress+(res[i].city?', '+res[i].city:'')+(res[i].state?', '+res[i].state:'')+(res[i].zip?', '+res[i].zip:'')+ ', Id :{'+res[i].propertyid+'}');
            }
            setMyOptions(myOptions);
            });
    }, []);

    

    

    const onSaving = React.useCallback((e) => {
        if (!e.changes || e.changes.length === 0) {
            return;
        }

        const change = e.changes[0];
        console.log(change);
        // Normalize all date fields to 'YYYY-MM-DD'
        const dateFields = ['abatement_start', 'abatement_end']; // Add more if needed
        dateFields.forEach((field) => {
            if (change.data?.[field] instanceof Date) {
                const date = change.data[field];
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                change.data[field] = `${year}-${month}-${day}`;
            }
        });

        if (change.type === "remove") {
            e.promise = axios.put(`${API_BASE_URL}api/leasedel`, { leaseid: change.key })
                .then(() => {
                    axios.get(`${API_BASE_URL}api/leaselist`).then(resp => {
                        if (resp.status === 200) {
                            setdataList(resp.data);
                        }
                    });
                });
        } else if (change.type === "update") {
            e.promise = axios.put(`${API_BASE_URL}api/leasegrid`, {
                leaseid: change.key,
                values: change.data,
                type: selHandleRef.current
            }).then(() => {
                Swal.fire('Done', 'Lease Updated Successfully!', 'success');
                // if(selHandleRef.current==='handleCreateNewVersion'){
                    // Refresh lease list
                    axios.get(`${API_BASE_URL}api/leaselist`).then(resp => {
                        if (resp.status === 200) {
                            setdataList(resp.data);
                        }
                    });
                    
                // }                
                selHandleRef.current = null;
            }).catch((error) => {
                console.error("Update failed:", error);
                Swal.fire('Error', 'Lease update failed.', 'error');
            });

        }
    }, []);
 

    const editModalopen = (leaseid) => {        
        setSellid(leaseid)
        setShowModalh(true);
    };

    const handleUpdateExisting = async () => {
        setShowModalh(false);
        selHandleRef.current = 'handleUpdateExisting';
        editLeaseById(Sellid)
    };

    const handleCreateNewVersion = async () => {
        setShowModalh(false);        
        selHandleRef.current = 'handleCreateNewVersion';
        editLeaseById(Sellid)                    
    };
    const onRowClick = ((e) => {
        
        if(e.data.hasOwnProperty('key')){            
        
        }else{
            getInfo(e.data)

        }
    });
    const [buildingsWithProperty, setBuildingsWithProperty] = useState([]);

    useEffect(() => {
    axios.get(`${API_BASE_URL}api/buildings-with-property`)
        .then(res => setBuildingsWithProperty(res.data))
        .catch(err => console.error(err));
    }, []);

    // Initial state for leaseData
    const initialLeaseData = {
        buildingid: "",
        bid: "",
        propertyid: "",
        propertyaddress: "",
        areasf: "",
        suites: [],
        selectedSuites: []
    };
    // State hook
    const [leaseData, setLeaseData] = useState(initialLeaseData);
    
    // Modal show handler
    const handleShow = () => {
        setLeaseData(initialLeaseData); // Reset leaseData
        setInternalStartDates([]);      // Reset internal start dates
        setInternalStopDates([]);       // Reset internal stop dates
        setShow(true);                  // Show modal
    };
    const optionKey = [
        { ID: "*", Name: "County Owned", value: "County Owned - *" },
        { ID: "^", Name: "County Maintained", value: "County Maintained - ^" },
        { ID: "LM", Name: "Leased Property - Maintained by County", value: "Leased Property - Maintained by County - LM" },
        { ID: "LN", Name: "Leased Property Non-maintained", value: "Leased Property Non-maintained – LN" },
        { ID: "0", Name: "Zero Maintenance Responsibility", value: "Zero Maintenance Responsibility – 0" },
        { ID: "CS", Name: "Custodial Stewardship", value: "Custodial Stewardship - CS" },
    ];

    const handleSelectProperty = (event, selected) => {
        if (!selected) return;
        setLeaseData((prev) => ({
        ...prev,
        buildingid: selected.buildingid,         
        bid: selected.bid,        
        propertyid: selected.propertyid,
        propertyaddress: selected.propertyaddress+','+selected.city+','+selected.state+','+selected.zip,
        areasf: selected.buildingsf,
        selectedSuites: []
        }));

        // Fetch suites for the selected property
        fetch(`${API_BASE_URL}api/buildingsuites/${selected.buildingid}`)
        .then((res) => res.json())
        .then((data) => setLeaseData((prev) => ({ ...prev, suites: data })));
    };

    const [suiteOptions, setSuiteOptions] = useState([]);

    const fetchSuitesForProperty = async (buildingid) => {
        try {
        const response = await axios.get(`${API_BASE_URL}api/buildingsuites/${buildingid}`);
        // Assume response.data is an array of { label, value } objects
        setSuiteOptions(response.data);
        } catch (err) {
        console.error("Error fetching suites:", err);
        setSuiteOptions([]);
        }
    };

    const onExporting = ((e) => {
        if (e.format === 'xlsx') {
            const workbook = new Workbook();
            const worksheet = workbook.addWorksheet('Data');
            exportDataGrid({
                component: e.component,
                worksheet,
                autoFilterEnabled: true,
                customizeCell: ({ gridCell, excelCell }) => {
                    if (
                        [
                        "Operating Expense",
                        "Other Expense",
                        "Annual Rent CAM",
                        "Annual Rent Other",
                        "Annual Rent Base 1",
                        "Annual Rent Base 2",
                        "Monthly Rent Base 1",
                        "Monthly Rent Base 2",
                        "Annual Abatement 1",
                        "Annual Abatement 2",
                        "Monthly Abatement 1",
                        "Monthly Abatement 2"
                        ].includes(gridCell.column.caption)
                    ) {
                        let value = gridCell.value;

                        if (typeof value === 'string') {
                            // Remove $ and commas and parse as float
                            const cleanedValue = parseFloat(value.replace(/[$,]/g, ''));
                            if (!isNaN(cleanedValue)) {
                                excelCell.value = cleanedValue;
                            }
                        }
                        excelCell.numFmt = '"$"#,##0.00';
                    }
                }
            }).then(() => {
                workbook.xlsx.writeBuffer().then((buffer) => {
                    saveAs(new Blob([buffer], { type: 'application/octet-stream' }), `LeaseDataFY${currentFY}.xlsx`);
                });
            });
        }
        
        else if (e.format === 'pdf') {
            const doc = new jsPDF();
            exportDataGridToPdf({
                jsPDFDocument: doc,
                component: e.component
            }).then(() => {
                doc.save('LeaseData.pdf');
            })
        };
    });
    let inputRef;
    const leaseTypeOptions = [
    { value: "In-Lease", label: "In Lease (Ownership – Non PGCO)" },
    { value: "Out-Lease", label: "Out Lease (Ownership – PGCO)" }
    ];

    const agreementOptions = [
    { value: "Lease", label: "Lease" },
    { value: "Sublease", label: "Sublease" },
    { value: "Use & Occupancy", label: "Use & Occupancy" },
    { value: "License", label: "License" },
    { value: "Easement", label: "Easement" },
    { value: "Other Agreement", label: "Other Agreement" }
    ];

    return(
        <div>
            <div className='LeasePage'>

<React.Fragment>
            

            <DataGrid
                keyExpr="leaseid"
                ref={gridRef}
                className={'dx-card wide-card'}
                dataSource={dataList}
                showRowLines={false}
                showBorders={true}
                columnAutoWidth={true}
                onRowClick={onRowClick}
                loadPanel={true}
                allowColumnReordering={true}
                allowColumnResizing={true}
                rowAlternationEnabled={true}
                onExporting={onExporting}
                onSaving={onSaving}
                onEditingStart={() => setFormMode("edit")}
                onInitNewRow={() => setFormMode("add")}
                // onContentReady={(e) => {
                //     if (!collapsedOnce) {
                //     e.component.collapseAll(2); // collapse only group level 2 (bid)
                //     setCollapsedOnce(true);     // prevent re-running
                //     }
                // }}
                
                >
                <Editing mode="popup"  allowUpdating={false} allowDeleting={true} allowEditing={true} 
                
                />
                
                <Toolbar>
                    <Item location="center" locateInMenu="auto">
                            <SelectBox                             
                            width="150" 
                            items={listedyears}
                            displayExpr="text"
                            valueExpr="value"
                            value={currentFY}
                            onValueChanged={setTarget}
                            className="fy-selectbox"
                            />

                    </Item>
                    
                    <Item
                        location="after"
                        locateInMenu="auto"
                        widget="dxButton"
                        options={{
                        text: "Add New",
                        type: "default",
                        stylingMode: "contained", // optional: "text", "outlined", "contained"
                        onClick: handleShow,
                        hint: "Add New",
                        icon: "add",
                        iconPosition: "after", 
                        elementAttr: { class: "btn-ads" }, // custom classes
                        }}
                    />
                    {/* Built-in toolbar items */}
                    {/* <Item name="addRowButton" /> */}
                    <Item name="exportButton" />
                    <Item name="searchPanel" />                    
                    <Item name="groupPanel" />
                </Toolbar>
                <ColumnFixing enabled={true} />
                <Paging defaultPageSize={25} />
                <Pager showPageSizeSelector={true} showInfo={true} allowedPageSizes={[5, 10, 25, 50, 100, 'all']} />
                <Export enabled={true} formats={exportFormats} allowExportSelectedData={true} />
                <SearchPanel visible={true} highlightCaseSensitive={true} />
                <Selection mode="multiple" />
                {/* <GroupPanel visible={true} /> */}
                <Column dataField="lnumber" caption='Lease ID'
                //  formItem={{ visible: false }} 
                 cellRender={(data) => {
                    const isDuplicate = data.value?.toUpperCase().includes("D"); // check if lnumber contains 'D'
                    return(<>
                    <div>{(data.data.brand == 1 ?
                    <b style={{color:"#C42929"}}>{data.value}</b>:                  
                    <div >{data.value}</div>
                    )}
                    {isDuplicate && (
                            <span
                                style={{
                                backgroundColor: "#ff0000",
                                color: "#fff",
                                fontSize: "11px",
                                padding: "2px 6px",
                                marginLeft:"4px",
                                borderRadius: "8px",
                                border: "1px solid #ff0000",
                                fontWeight: 500,
                                }}
                            >
                                Duplicate
                            </span>
                            )}
                    </div></>)
                }} />
                
               

                
                <Column dataField={'days'} formItem={{visible:false}} caption={'Status'} allowEditing={false} cellRender={(data) => {
                    return(<>
                    <div>{(data.value <=30 ?
                    <div style={{color:"#C42929"}}>{data.value} Days</div>:                  
                    <div style={{color:"green"}}>{data.value} Days</div>
                    )}</div></>)
                }} />
                <Column dataType={String} allowEditing={false} allowExporting={false} formItem={{visible:false}} cellRender={(data)=>{
                    let addrs = data.data.propertyaddress;
                    if(data.data.city){
                        addrs =addrs+','+data.data.city;
                    }
                    if(data.data.state){
                        addrs =addrs+','+data.data.state;
                    }
                    return (<><a href="#" title="Location" onClick={()=>{  
                        getImg(data.data.propertyid) 
                    }
                    }>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <g clip-path="url(#clip0_221_3815)">
                                <path d="M8.00037 10.6667C8.31081 10.6673 8.61709 10.5956 8.89503 10.4573L10.2284 9.79068C10.908 9.45325 11.3367 8.75878 11.3337 8.00003V6.02203C11.3361 5.26393 10.9074 4.57037 10.2284 4.23337L8.89503 3.56672C8.33168 3.28672 7.66971 3.28672 7.10637 3.56672L5.77303 4.23337C5.09371 4.57018 4.66481 5.26381 4.66703 6.02203V8.00003C4.66459 8.75831 5.09318 9.45212 5.77237 9.78937L7.10571 10.456C7.38353 10.5947 7.68984 10.6669 8.00037 10.6667ZM6.00037 8.00003V6.02203C6.00143 5.95403 6.0129 5.88656 6.03437 5.82203L7.48771 6.54868C7.81046 6.71 8.19031 6.71 8.51306 6.54868L9.9664 5.82203C9.98787 5.88656 9.99934 5.95403 10.0004 6.02203V8.00003C10.0015 8.25296 9.85843 8.48446 9.63175 8.59668L8.2984 9.26334C8.1104 9.35637 7.88975 9.35637 7.70175 9.26334L6.3684 8.59668C6.14193 8.48428 5.99918 8.25284 6.00037 8.00003ZM12.667 14.6667H10.861L13.1857 12.5187C16.0496 9.65487 16.0497 5.01168 13.1858 2.14778C10.322 -0.716128 5.67887 -0.71616 2.81496 2.14762C-0.0489414 5.0114 -0.0490041 9.65465 2.81481 12.5185C2.82109 12.5248 5.13971 14.6667 5.13971 14.6667H3.33371C2.96553 14.6667 2.66706 14.9652 2.66706 15.3333C2.66706 15.7015 2.96553 16 3.33371 16H12.6671C13.0352 16 13.3337 15.7015 13.3337 15.3333C13.3337 14.9652 13.0352 14.6667 12.667 14.6667ZM3.75771 3.09068C6.09571 0.742184 9.89487 0.733684 12.2434 3.07168C14.5919 5.40968 14.6004 9.20884 12.2624 11.5573L9.60571 14.0113C8.69897 14.866 7.28178 14.861 6.38106 14L3.75771 11.576C1.41818 9.23134 1.41821 5.43537 3.75771 3.09068Z" fill="#1AC152"/>
                            </g>
                            <defs>
                                <clipPath id="clip0_221_3815">
                                <rect width="16" height="16" fill="white"/>
                                </clipPath>
                            </defs>
                            </svg>
                    </a>&nbsp;&nbsp;<a href="#" title="Map Location"  onClick={()=>{
                        Geocode.setApiKey("AIzaSyBxLd_UmZ_U0NLhQvqTLd-Ek_k3SbOkykI")
                        Geocode.setLanguage("en");
                        Geocode.setLocationType("ROOFTOP");
                        console.log("geocode")
                        Geocode.fromAddress(addrs).then(
                        (response) => {
                            console.log(response.results[0].geometry.location)
                            lat = response.results[0].geometry.location.lat;
                            lng = response.results[0].geometry.location.lng
                            setLocation({lat:lat, lng:lng, name: data.value});
                            console.log(`Lat:${lat}Lng:${lng}`)
                        })
                        setMapModal(true)
                        }
                        }>
                           <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <path d="M7 4.639V18.5M13 1V15M1 6.71C1 5.236 1 4.5 1.393 4.07C1.53209 3.91703 1.70129 3.79447 1.89 3.71C2.422 3.474 3.121 3.707 4.519 4.173C5.586 4.529 6.119 4.707 6.659 4.688C6.8571 4.68149 7.05406 4.65536 7.247 4.61C7.772 4.485 8.24 4.173 9.176 3.55L10.558 2.628C11.758 1.828 12.357 1.428 13.045 1.337C13.733 1.244 14.417 1.472 15.784 1.928L16.949 2.316C17.939 2.646 18.434 2.811 18.717 3.204C19 3.597 19 4.119 19 5.162V13.291C19 14.764 19 15.501 18.607 15.931C18.4677 16.0832 18.2985 16.2051 18.11 16.289C17.578 16.526 16.879 16.293 15.481 15.827C14.414 15.471 13.881 15.293 13.341 15.312C13.1429 15.3185 12.9459 15.3446 12.753 15.39C12.228 15.515 11.76 15.827 10.824 16.45L9.442 17.372C8.242 18.172 7.643 18.572 6.955 18.663C6.267 18.756 5.583 18.528 4.216 18.072L3.051 17.684C2.061 17.354 1.566 17.189 1.283 16.796C1 16.403 1 15.88 1 14.838V6.71Z" stroke="#E8AB4E" stroke-width="1.5"/>
                                    </svg>
                        
                        </a></>)
                    
                }}/>
                <Column
                    dataField="buildingid"
                    caption="Select Property"
                    colSpan={2}
                    visible={false}
                    formItem={{
                        visible: formMode === 'add',
                        colSpan: 2,
                        editorType: "dxSelectBox",
                        editorOptions: {
                        dataSource: buildingsWithProperty,
                        displayExpr: "label",
                        valueExpr: "buildingid",
                        searchEnabled: true,
                        placeholder: "Search Property / Building",
                        onValueChanged: async (e) => {
                        if (!e.value) return;


                        const selected = buildingsWithProperty.find(
                            (b) => b.buildingid === e.value
                        );
                        if (selected) {
                            // Fetch suites from API and update suite multi-select options
                            await fetchSuitesForProperty(e.value);

                            const form = e.component.option("form");
                            if (form && form.updateData) {
                            form.updateData("propertyaddress", selected.propertyaddress);
                            form.updateData("areasf", selected.buildingsf);
                            form.updateData("propertyid", selected.propertyid);
                            // Fetch suites from API and update suite multi-select options
                            await fetchSuitesForProperty(e.value);
                            
                            form.updateData("suitenumbers", []); // reset suite selection
                            }
                        }
                        },
                    },
                    }}
                    />


                <Column dataField="propertyid" visible={false} formItem={{ visible: false }}  />

                <Column dataField={'propertyaddress'} caption={'Property Address'} allowEditing={false} cellRender={(data)=>{ return (<>{data.value+', '+data.data.city+', '+data.data.state+' '+data.data.zip}</>)}} 
                //  groupIndex={1}   showWhenGrouped={true}
                groupCellRender={(cellInfo) => {return (<div style={{ fontWeight: "bold", color: "teal" }}>Property : {cellInfo.value}</div>);}}
                />
                <Column
                dataField="suites"
                caption="Suites"
                editCellRender={(cell) => (
                    <SuitesEditor data={cell.data} setValue={cell.setValue} />
                )}
                cellRender={({ value }) =>
                    Array.isArray(value)
                    ? value.filter(s => s?.suitenumber).map(s => s.suitenumber).join(", ")
                    : ""
                }
                />
                
                <Column caption='Comments' dataField='commentcount' formItem={{visible:false}} allowExporting={false} allowSorting={false} cellRender={(data) =>{
                    {
                    return ( <><a  href="#" title="Comments" onClick={()=>{
                        setCommentPID(data.data.leaseid)
                        console.log("Accessing Comments")
                        axios.get(`${API_BASE_URL}api/leasecomment/${data.data.leaseid}`, (err, result)=>{
    
                            // console.log("received")
                            // console.log(result)
                            // setComment({Comment:result[0][0].comment, date: result[0][0].createdate})
                            // setCommentModal(!commentModal);

                        }).then(result => {
                            
                            const _Comments = result.data || null;
                            console.log(_Comments)
                            setComment(_Comments)
                            
                            setCommentModal(!commentModal);
                        })
                    }}>
                    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M22.4604 3.84888H5.31685C4.64745 3.84961 4.00568 4.11586 3.53234 4.58919C3.059 5.06253 2.79276 5.7043 2.79202 6.3737V18.1562C2.79276 18.8256 3.059 19.4674 3.53234 19.9407C4.00568 20.4141 4.64745 20.6803 5.31685 20.6811C5.54002 20.6812 5.75401 20.7699 5.91181 20.9277C6.06961 21.0855 6.15832 21.2995 6.15846 21.5227V23.3168C6.15846 23.6215 6.24115 23.9204 6.39771 24.1818C6.55427 24.4431 6.77882 24.6571 7.04744 24.8009C7.31605 24.9446 7.61864 25.0128 7.92295 24.9981C8.22726 24.9834 8.52186 24.8863 8.77536 24.7173L14.6173 20.8224C14.7554 20.7299 14.9179 20.6807 15.0841 20.6811H19.187C19.7383 20.68 20.2743 20.4994 20.7137 20.1664C21.1531 19.8335 21.472 19.3664 21.6222 18.8359L24.8965 7.05011C24.9999 6.67481 25.0152 6.28074 24.9413 5.89856C24.8675 5.51637 24.7064 5.15639 24.4707 4.84663C24.235 4.53687 23.9309 4.28568 23.5823 4.11263C23.2336 3.93957 22.8497 3.84931 22.4604 3.84888ZM23.2733 6.60304L20.0006 18.3847C19.95 18.5614 19.8432 18.7168 19.6964 18.8275C19.5496 18.9381 19.3708 18.9979 19.187 18.9978H15.0841C14.5856 18.9972 14.0981 19.1448 13.6836 19.4219L7.84168 23.3168V21.5227C7.84094 20.8533 7.5747 20.2115 7.10136 19.7382C6.62802 19.2648 5.98625 18.9986 5.31685 18.9978C5.09368 18.9977 4.87969 18.909 4.72189 18.7512C4.56409 18.5934 4.47537 18.3794 4.47524 18.1562V6.3737C4.47537 6.15054 4.56409 5.93655 4.72189 5.77874C4.87969 5.62094 5.09368 5.53223 5.31685 5.5321H22.4604C22.5905 5.53243 22.7188 5.56277 22.8352 5.62076C22.9517 5.67875 23.0532 5.76283 23.1318 5.86646C23.2105 5.97008 23.2641 6.09045 23.2887 6.21821C23.3132 6.34597 23.3079 6.47766 23.2733 6.60304Z" fill="#3B4CB8"></path><path d="M7.84167 11.4233H12.0497C12.2729 11.4233 12.487 11.3347 12.6448 11.1768C12.8027 11.019 12.8913 10.8049 12.8913 10.5817C12.8913 10.3585 12.8027 10.1444 12.6448 9.98661C12.487 9.82878 12.2729 9.74011 12.0497 9.74011H7.84167C7.61846 9.74011 7.4044 9.82878 7.24656 9.98661C7.08873 10.1444 7.00006 10.3585 7.00006 10.5817C7.00006 10.8049 7.08873 11.019 7.24656 11.1768C7.4044 11.3347 7.61846 11.4233 7.84167 11.4233Z" fill="#3B4CB8"></path><path d="M15.4162 13.1066H7.84167C7.61846 13.1066 7.4044 13.1952 7.24656 13.3531C7.08873 13.5109 7.00006 13.725 7.00006 13.9482C7.00006 14.1714 7.08873 14.3855 7.24656 14.5433C7.4044 14.7011 7.61846 14.7898 7.84167 14.7898H15.4162C15.6394 14.7898 15.8534 14.7011 16.0113 14.5433C16.1691 14.3855 16.2578 14.1714 16.2578 13.9482C16.2578 13.725 16.1691 13.5109 16.0113 13.3531C15.8534 13.1952 15.6394 13.1066 15.4162 13.1066Z" fill="#3B4CB8"></path></svg>
                    <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-info text-white">{data.value ===0?'+':data.value}</span></a>
                    </>)                }

                    // else{
                    // return (<></>)
                    // }
                    }} />
                {/* <Column dataField={'lnumber'} caption={'LNumber'} /> */}
                <Column dataField={'leasetype'} caption={'Lease Type'} groupIndex={0} >
                    <Lookup dataSource={leaseTypeOptions} valueExpr="value" displayExpr="label" />
                </Column>
                
                {/* <Column dataField="bid"  caption='Building ID/L#' groupIndex={2} allowSorting={false} showWhenGrouped={false} formItem={{visible:false}}/> */}
                
                <Column dataField={'agreement'} caption={'Agreement Type'}>
                    <Lookup dataSource={agreementOptions} valueExpr="value" displayExpr="label" />
                </Column>
                <Column dataField={'agencyname'} caption={'Agency'} />
                <Column dataField={'areasf'} caption={'Lease Sq. Ft'} dataType={Number} format={'#,###'}   />
                <Column dataField={'tenantcontactname'} caption={'Tenant Contact Name'} />
                <Column dataField={'tenantcontactphone1'} caption={'Tenant Contact Phone 1'} />
                <Column dataField={'tenantcontactphone2'} caption={'Tenant Contact Phone 2'} />
                <Column dataField={'tenantcontactemail1'} caption={'Tenant Contact Email 1'} />
                <Column dataField={'tenantcontactemail2'} caption={'Tenant Contact Email 2'} />
                <Column dataField={'landlordname'} caption={'Landlord Name'} />
                <Column dataField={'landlordphone1'} caption={'Landlord Phone 1'} />
                <Column dataField={'landlordphone2'} caption={'Landlord Phone 2'} />
                <Column dataField={'landlordemail1'} caption={'Landlord Email 1'} />
                <Column dataField={'landlordemail2'} caption={'Landlord Email 2'} />
                <Column dataField={'commence_date'} caption={'Commence'} dataType={'date'} format={'MM/dd/yyyy'}  />
                <Column dataField={'expiration_date'} caption={'Expiration'} dataType={'date'} format={'MM/dd/yyyy'}  />
                <Column dataField={'rental_commence_date'} caption={'Rental Commence Date'} dataType={'date'} format={'MM/dd/yyyy'}  />
                    

                <Column
                    dataField="internal_stop_dates"
                    caption="Internal Stop Dates"
                    visible={false}
                    formItem={{ visible: true,
                                helpText: "Enter the stop dates like 06/30/2025,10/31/2027"
                     }}
                     calculateCellValue={(rowData) => {
                            if (!Array.isArray(rowData.internal_stop_dates)) return "";

                            return rowData.internal_stop_dates
                                .map(dateStr => {
                                    const [year, month, day] = dateStr.split("-");
                                    return `${month}/${day}/${year}`; // MM/DD/YYYY
                                })
                                .join(", ");
                        }}
                        setCellValue={(rowData, value) => {
                            if (typeof value === "string") {
                                const parsedDates = value
                                    .split(",")
                                    .map(v => {
                                        const parts = v.trim().split("/");
                                        if (parts.length === 3) {
                                            let [month, day, year] = parts;
                                            if (month && day && year) {
                                                month = month.padStart(2, "0");
                                                day = day.padStart(2, "0");
                                                return `${year}-${month}-${day}`; // YYYY-MM-DD
                                            }
                                        }
                                        return null; // skip invalid date
                                    })
                                    .filter(Boolean);

                                rowData.internal_stop_dates = parsedDates;
                            } else if (Array.isArray(value)) {
                                rowData.internal_stop_dates = value;
                            } else {
                                rowData.internal_stop_dates = [];
                            }
                        }}
                />
                           
                <Column caption={'Operating Expense'} dataType={Number} format={"'$'#0.##"}  formItem={{visible:false}} allowEditing={false}
                    calculateCellValue={(rowData) => {
                        const fyValues = getFYBaseRentValues(currentFY, rowData);
                        const months1 = fyValues.months1 ?? 0;
                        const months2 = fyValues.months2 ?? 0;
                        const monthlyCam = rowData.monthlyrentcam ?? 0;

                        return (monthlyCam * (months1 + months2)).toFixed(2);
                    }}  
                    customizeText={customizeCurrencyText}              
                />
                              
                <Column caption={'Other Expense'} dataType={Number} format={"'$'#0.##"}  formItem={{visible:false}} allowEditing={false}
                    calculateCellValue={(rowData) => {
                        const fyValues = getFYBaseRentValues(currentFY, rowData);
                        const months1 = fyValues.months1 ?? 0;
                        const months2 = fyValues.months2 ?? 0;
                        const monthlyOther = rowData.monthlyrentother ?? 0;

                        return (monthlyOther * (months1 + months2)).toFixed(2);
                    }}   
                    customizeText={customizeCurrencyText}             
                />
                
                <Column dataField={'renewalterm'} caption={'Renewal'} />
                <Column dataField={'escalationpercent'} caption={'Escalation'} dataType={Number} format={"#0.##'%'"} />    
                              
                <Column caption={'Annual Rent CAM'} dataType="number" format={"'$'#0.##"}  formItem={{visible:false}} allowEditing={false}
                    calculateCellValue={(rowData) => {
                        const fyValues = getFYBaseRentValues(currentFY, rowData);
                        const months1 = fyValues.months1 ?? 0;
                        const months2 = fyValues.months2 ?? 0;
                        const monthlyCam = rowData.monthlyrentcam ?? 0;

                        return (monthlyCam * (months1 + months2)).toFixed(2);
                    }}    
                    customizeText={customizeCurrencyText}            
                />
                              
                <Column caption={'Annual Rent Other'} dataType="number" format={"'$'#0.##"}  formItem={{visible:false}} allowEditing={false}
                    calculateCellValue={(rowData) => {
                        const fyValues = getFYBaseRentValues(currentFY, rowData);
                        const months1 = fyValues.months1 ?? 0;
                        const months2 = fyValues.months2 ?? 0;
                        const monthlyOther = rowData.monthlyrentother ?? 0;

                        return (monthlyOther * (months1 + months2)).toFixed(2);
                    }}    
                    customizeText={customizeCurrencyText}            
                />
                <Column caption={'Annual Rent Base 1'} dataType="number" format={"'$'#0.##"}  formItem={{visible:false}} allowEditing={false}
                    calculateCellValue={(rowData) => {
                        const fyValues = getFYBaseRentValues(currentFY, rowData);
                        return fyValues.monthlyBase1 && fyValues.months1
                        ? (fyValues.monthlyBase1 * fyValues.months1).toFixed(2)
                        : null;
                    }}       
                    customizeText={customizeCurrencyText}         
                />
                <Column caption={'Annual Rent Base 2'} dataType="number" format={"'$'#0.##"} formItem={{visible:false}} allowEditing={false}

                    calculateCellValue={(rowData) => {
                        const fyValues = getFYBaseRentValues(currentFY, rowData);
                        return fyValues.monthlyBase2 && fyValues.months2
                        ? (fyValues.monthlyBase2 * fyValues.months2).toFixed(2)
                        : null;
                    }}
                    customizeText={customizeCurrencyText}
                />
                <Column caption={'Monthly Rent Base 1'} dataType="number" format={"'$'#0.##"}  formItem={{visible:false}} allowEditing={false}            
                    calculateCellValue={(rowData) => {
                        const fyValues = getFYBaseRentValues(currentFY, rowData);
                        return fyValues.monthlyBase1 ? fyValues.monthlyBase1.toFixed(2) : null;
                    }}    
                    customizeText={customizeCurrencyText}             
                />
                <Column caption={'Monthly Rent Base 2'} dataType="number" format={"'$'#0.##"} formItem={{visible:false}} allowEditing={false}
                    calculateCellValue={(rowData) => {
                        const fyValues = getFYBaseRentValues(currentFY, rowData);
                        return fyValues.monthlyBase2 ? fyValues.monthlyBase2.toFixed(2) : null;
                    }}
                    customizeText={customizeCurrencyText} 
                />
                <Column dataField={'monthlyrentcam'} caption={'Monthly Rent CAM'} dataType={Number} format={"'$'#0.##"} />
                <Column dataField={'monthlyrentother'} caption={'Monthly Rent Other'} dataType={Number} format={"'$'#0.##"} />
                <Column caption="PSF" dataType="number" format={"#0.00"} formItem={{ visible: false }} allowEditing={false}
                    calculateCellValue={(rowData) => {
                        const fyValues = getFYBaseRentValues(currentFY, rowData);
                        return fyValues.psf1 ?? null;
                    }}
                />
                <Column visible={false} dataType={Number} dataField={'rentpersf'} caption={'Rent per SF'} 
                    formItem={{
                        helpText: "Enter the full rent per square foot amount, including decimal values (e.g :25.244145888)."
                    }} 
                />
                <Column visible={false} dataType="number" dataField={'nonrentpersf'} caption={'Non Rent per SF'} />  
                {/* <Column dataField={'annualrentin'} formItem={{visible: false }} allowEditing={false}  caption={'Annual Rent in'} dataType={Number} format={"'$'#0.##"} cellRender={(data)=>{
                     
                     
                     let Mb = calculateValue(data.data.commence_date, data.data.leaseyear, data.data.expiration_date, data.data.rentpersf, data.data.areasf, data.data.escalationpercent)                    
                     data.value=Mb
                     return (<>${(parseFloat((Mb).toFixed(2)).toLocaleString()|| 0)}</>)
                     }}/> */}
                
                <Column caption={'Annual Abatement 1'} dataType="number" format={"'$'#0.##"}  formItem={{visible:false}} allowEditing={false}            
                    calculateCellValue={(rowData) => {
                        const fyValues = getFYBaseRentValues(currentFY, rowData);
                        return fyValues.annualAbatement1 ? fyValues.annualAbatement1.toFixed(2) : null;
                    }}    
                    customizeText={customizeCurrencyText}             
                />
                <Column caption={'Annual Abatement 2'} dataType="number" format={"'$'#0.##"} formItem={{visible:false}} allowEditing={false}
                    calculateCellValue={(rowData) => {
                        const fyValues = getFYBaseRentValues(currentFY, rowData);
                        return fyValues.annualAbatement2 ? fyValues.annualAbatement2.toFixed(2) : null;
                    }}
                    customizeText={customizeCurrencyText} 
                />
                
                <Column caption={'Monthly Abatement 1'} dataType="number" format={"'$'#0.##"}  formItem={{visible:false}} allowEditing={false}            
                    calculateCellValue={(rowData) => {
                        const fyValues = getFYBaseRentValues(currentFY, rowData);
                        return fyValues.monthlyAbatement1 ? fyValues.monthlyAbatement1.toFixed(2) : null;
                    }}    
                    customizeText={customizeCurrencyText}             
                />
                <Column caption={'Monthly Abatement 2'} dataType="number" format={"'$'#0.##"} formItem={{visible:false}} allowEditing={false}
                    calculateCellValue={(rowData) => {
                        const fyValues = getFYBaseRentValues(currentFY, rowData);
                        return fyValues.monthlyAbatement2 ? fyValues.monthlyAbatement2.toFixed(2) : null;
                    }}
                    customizeText={customizeCurrencyText} 
                />
                <Column  visible={false}  dataField="abatement_start"   caption="Abatement Start"   dataType="date"   format="MM/dd/yyyy" />
                <Column visible={false} dataField={'abatement_end'} caption={'Abatement End'} dataType={'date'} format={'MM/dd/yyyy'}  />
                <Column  dataField="fundingsource"  caption="Funding Source"  dataType="string"  allowEditing={true} />
                <Column  dataField="fundingagency"  caption="Funding Agency"  dataType="string"  allowEditing={true} />
                <Column dataField={'leaseyear'} allowEditing={false}  caption={'Lease Year'} dataType={Number} />              
                <Column dataField={'subleaseflag'} caption={'Sub Lease'} >
                    <Lookup dataSource={optionYesNo} valueExpr="ID" displayExpr="Name" />
                </Column>
                
                <Column dataField={'leasterminateddate'} caption={'Termination Date'} dataType={'date'} format={'MM/dd/yyyy'}  />
                <Column dataField={'leaseterminatedflag'} caption={'Terminated Lease'}>
                    <Lookup dataSource={optionYesNo} valueExpr="ID" displayExpr="Name" />
                </Column>
                <Column width={40} allowEditing={false} editCellRender={()=>{ return (<><input type="hidden" /></>)}} fixed={true} fixedPosition="right" cellRender={(data)=>{ return (<><a style={{cursor:'pointer'}} onClick={()=>{ 
                    setDropShow(true) 
                    setPrID(data.data.propertyid) } } className="" title="Upload" aria-label="Upload" >
                    <svg width="24" height="24" viewBox="0 0 24.00 24.00" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" stroke="#CCCCCC" stroke-width="4.8"> <path opacity="0.5" d="M3 15C3 17.8284 3 19.2426 3.87868 20.1213C4.75736 21 6.17157 21 9 21H15C17.8284 21 19.2426 21 20.1213 20.1213C21 19.2426 21 17.8284 21 15" stroke="#26975A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M12 16V3M12 3L16 7.375M12 3L8 7.375" stroke="#26975A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> </g><g id="SVGRepo_iconCarrier"> <path opacity="0.5" d="M3 15C3 17.8284 3 19.2426 3.87868 20.1213C4.75736 21 6.17157 21 9 21H15C17.8284 21 19.2426 21 20.1213 20.1213C21 19.2426 21 17.8284 21 15" stroke="#26975A" stroke-width="1.752" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M12 16V3M12 3L16 7.375M12 3L8 7.375" stroke="#26975A" stroke-width="1.752" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
                    </a></>)}} />
                <Column width={40} allowEditing={false} editCellRender={()=>{ return (<><input type="hidden" /></>)}} fixed={true} fixedPosition="right" cellRender={(data)=>{ return (<>
                    
                    <a style={{cursor:'pointer'}} onClick={()=>{ 
                    
                    getFiles(data.data.propertyid) } } className="" title="File Manager" aria-label="File Manager" >
                    <svg height="24" width="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M13 7L11.8845 4.76892C11.5634 4.1268 11.4029 3.80573 11.1634 3.57116C10.9516 3.36373 10.6963 3.20597 10.4161 3.10931C10.0992 3 9.74021 3 9.02229 3H5.2C4.0799 3 3.51984 3 3.09202 3.21799C2.71569 3.40973 2.40973 3.71569 2.21799 4.09202C2 4.51984 2 5.0799 2 6.2V7M2 7H17.2C18.8802 7 19.7202 7 20.362 7.32698C20.9265 7.6146 21.3854 8.07354 21.673 8.63803C22 9.27976 22 10.1198 22 11.8V16.2C22 17.8802 22 18.7202 21.673 19.362C21.3854 19.9265 20.9265 20.3854 20.362 20.673C19.7202 21 18.8802 21 17.2 21H6.8C5.11984 21 4.27976 21 3.63803 20.673C3.07354 20.3854 2.6146 19.9265 2.32698 19.362C2 18.7202 2 17.8802 2 16.2V7ZM12 17V11M9 14H15" stroke="#2C3175" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
                    </a>
                    </>)}} />
                <Column width={40} allowEditing={false} editCellRender={() => <input type="hidden" />} fixed={true} fixedPosition="right" 
                    cellRender={(data) => (
                        <>
                        <a
                            style={{ cursor: 'pointer' }}
                            onClick={() => openDuplicateModal(data.data)}
                            title="Duplicate Lease"
                            aria-label="Duplicate Lease"
                        >
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M4 4H14V14H4V4Z" stroke="#337AB7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M10 10H20V20H10V10Z" stroke="#337AB7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </a>
                        </>
                    )}
                    />
                
                <Column width={40} allowEditing={false} editCellRender={() => <input type="hidden" />} fixed={true} fixedPosition="right" 
                    cellRender={(data) => (
                        <>
                        <a
                            style={{ cursor: 'pointer' }}
                            onClick={() => handleDuplicateLease(data.data)}
                            title="Renew Lease"
                            aria-label="Renew Lease"
                        >
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fill-rule="evenodd" clip-rule="evenodd" d="M22 2H2V22H22V2ZM20 4H4V20H20V4Z" fill="#34bc5d"></path> <path fill-rule="evenodd" clip-rule="evenodd" d="M12 8.27273C9.89364 8.27273 8.18182 9.98455 8.18182 12.0909H10.0909L7.54545 14.6364L5 12.0909H6.90909C6.90909 9.27818 9.18727 7 12 7C12.9991 7 13.9282 7.29273 14.7109 7.78909L13.7818 8.71818C13.2536 8.43182 12.6427 8.27273 12 8.27273ZM13.9091 12.0909L16.4545 9.54545L19 12.0909H17.0909C17.0909 14.9036 14.8127 17.1818 12 17.1818C11.0009 17.1818 10.0718 16.8891 9.28909 16.3927L10.2182 15.4636C10.7464 15.75 11.3573 15.9091 12 15.9091C14.1064 15.9091 15.8182 14.1973 15.8182 12.0909H13.9091Z" fill="#34bc5d"></path> </g></svg>
                        </a>
                        </>
                    )}
                    />
                
                <Column width={40} allowEditing={false} editCellRender={() => <input type="hidden" />} fixed={true} fixedPosition="right" 
                    cellRender={(data) => (
                        <>
                        <a
                            style={{ cursor: 'pointer' }}
                            onClick={() => editModalopen(data.data.leaseid)}
                            title="Edit Lease"
                            aria-label="Duplicate Lease"
                        >
                            <div className=' dx-icon-edit edi-cs' ></div>
                        </a>
                        </>
                    )}
                    />
                
                

            </DataGrid>
            <Modal
            size="lg"
            show={imgShow} onHide={imgmodClose}
            aria-labelledby="contained-modal-title-vcenter"
            centered
            >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                Location : {galleryTitle}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
            <div style={{maxHeight:"520px", width:"100%"}}>
                        {viewer}
                        </div>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={imgmodClose}>Close</Button>
            </Modal.Footer>
            </Modal>


            <Modal
            size="xl"
            scrollable
            show={modalShow} onHide={modClose}
            aria-labelledby="contained-modal-title-vcenter"
            centered
            className='lease-details'
            >
            <Modal.Header closeButton>
                <div className="d-flex flex-column w-100">
                    <div className="d-flex justify-content-between align-items-center w-100">
                        <Modal.Title id="contained-modal-title-vcenter">
                            Lease Details: {infoDetail?.propertyaddress || "-"}
                        </Modal.Title>

                        {leaseVersions.length > 0 && (
                            <select
                                className="form-control v-sel form-control-sm w-auto mr-5"
                                value={selectedLeaseId}
                                onChange={(e) => {
                                    const leaseId = e.target.value;
                                    setSelectedLeaseId(leaseId);
                                    fetchLeaseDetails(leaseId);
                                }}
                            >
                                {leaseVersions.map((lease) => (
                                    <option key={lease.leaseid} value={lease.leaseid}>
                                        Version {lease.version || lease.leaseid}
                                    </option>
                                ))}
                            </select>
                        )}
                    </div>
                </div>
            </Modal.Header>

            <Modal.Body>
            <div style={{width:'100%'}}>
                <Box sx={{ flexGrow: 1 }}>
                            <Grid container spacing={2}>
                                <Grid item xs={12} md={6}>
                                    <div className='info-row'><div className='info-label'>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                        <g clip-path="url(#clip0_218_3380)">
                                            <path d="M15.182 5.14763C14.8694 4.78736 14.483 4.49848 14.0491 4.30053C13.6151 4.10258 13.1437 4.00019 12.6667 4.00029H10.0073L10.2313 2.63963C10.3106 2.16047 10.215 1.66878 9.96191 1.25425C9.70885 0.839722 9.31521 0.529968 8.8528 0.381487C8.39038 0.233006 7.89 0.255693 7.44292 0.445409C6.99584 0.635125 6.63184 0.979229 6.41733 1.41496L5.14133 4.00029H3.33333C2.4496 4.00135 1.60237 4.35288 0.97748 4.97777C0.352588 5.60266 0.00105857 6.4499 0 7.33363L0 10.667C0.00105857 11.5507 0.352588 12.3979 0.97748 13.0228C1.60237 13.6477 2.4496 13.9992 3.33333 14.0003H12.2C13.0023 13.997 13.7768 13.7058 14.3825 13.1797C14.9883 12.6536 15.3851 11.9276 15.5007 11.1336L15.9707 7.80029C16.0369 7.32745 16.0007 6.8459 15.8646 6.38825C15.7286 5.93059 15.4958 5.5075 15.182 5.14763ZM1.33333 10.667V7.33363C1.33333 6.80319 1.54405 6.29449 1.91912 5.91941C2.29419 5.54434 2.8029 5.33363 3.33333 5.33363H4.66667V12.667H3.33333C2.8029 12.667 2.29419 12.4562 1.91912 12.0812C1.54405 11.7061 1.33333 11.1974 1.33333 10.667ZM14.6473 7.61296L14.1767 10.9463C14.1079 11.4223 13.8705 11.8578 13.5077 12.1735C13.145 12.4893 12.6809 12.6644 12.2 12.667H6V5.15629C6.06283 5.10156 6.11484 5.03553 6.15333 4.96163L7.61267 2.00496C7.66739 1.90625 7.74476 1.82193 7.83842 1.75893C7.93207 1.69594 8.03934 1.65607 8.1514 1.6426C8.26346 1.62913 8.37712 1.64244 8.48304 1.68144C8.58896 1.72045 8.6841 1.78403 8.76067 1.86696C8.82617 1.94312 8.87405 2.0328 8.9009 2.1296C8.92775 2.2264 8.93291 2.32794 8.916 2.42696L8.564 4.56029C8.54855 4.65561 8.55399 4.75315 8.57995 4.84616C8.60591 4.93917 8.65176 5.02543 8.71433 5.09898C8.77691 5.17252 8.85472 5.2316 8.94237 5.27211C9.03003 5.31263 9.12544 5.33361 9.222 5.33363H12.6667C12.9529 5.33359 13.2359 5.395 13.4964 5.51372C13.7569 5.63244 13.9888 5.8057 14.1766 6.02178C14.3644 6.23787 14.5036 6.49174 14.5848 6.76625C14.666 7.04075 14.6873 7.3295 14.6473 7.61296Z" fill="#C42929"/>
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_218_3380">
                                            <rect width="16" height="16" fill="white"/>
                                            </clipPath>
                                        </defs>
                                        </svg>
                                         Status : </div><div className='info-value'>{(infoDetail.days <=30 ?<div style={{color:"#C42929"}}>{infoDetail.days} Days</div>: <div style={{color:"green"}}>{infoDetail.days} Days</div> )}</div></div>
                                    <div className='info-row'><div className='info-label'> 
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                        <g clip-path="url(#clip0_218_3381)">
                                            <path d="M8.00016 0C6.54754 3.29195e-05 5.12765 0.431477 3.92058 1.23961C2.71351 2.04775 1.77364 3.19616 1.22016 4.53921C0.66669 5.88226 0.524554 7.35942 0.811783 8.78336C1.09901 10.2073 1.80266 11.5139 2.8335 12.5373L5.46216 14.9647C6.13782 15.626 7.04497 15.9975 7.99045 16C8.93593 16.0025 9.84503 15.6358 10.5242 14.978L13.1855 12.5187C14.211 11.4931 14.9094 10.1864 15.1924 8.76393C15.4753 7.34144 15.3301 5.86698 14.7751 4.52702C14.22 3.18706 13.2801 2.04176 12.0742 1.23596C10.8683 0.430164 9.45052 4.60393e-05 8.00016 0V0ZM12.2615 11.558L9.6055 14.012C9.16877 14.4235 8.59079 14.6516 7.99077 14.6494C7.39075 14.6471 6.81448 14.4147 6.38083 14L3.7575 11.576C3.0598 10.8783 2.54493 10.0193 2.25851 9.07507C1.97209 8.13085 1.92296 7.13057 2.11545 6.16283C2.30795 5.19509 2.73614 4.28975 3.3621 3.52702C3.98806 2.76429 4.79246 2.16771 5.70405 1.79011C6.61565 1.41252 7.6063 1.26556 8.58825 1.36228C9.5702 1.45899 10.5131 1.79637 11.3336 2.34455C12.154 2.89273 12.8265 3.63478 13.2917 4.50497C13.7568 5.37516 14.0002 6.34663 14.0002 7.33333C14.0031 8.11736 13.851 8.89422 13.5526 9.61925C13.2542 10.3443 12.8154 11.0032 12.2615 11.558ZM11.1402 5.10867L9.14016 3.72133C8.80509 3.4898 8.40745 3.36578 8.00016 3.36578C7.59287 3.36578 7.19524 3.4898 6.86016 3.72133L4.86016 5.10867C4.59477 5.29278 4.37791 5.53843 4.22815 5.82461C4.07838 6.1108 4.00016 6.429 4.00016 6.752V9C4.00016 9.44203 4.17576 9.86595 4.48832 10.1785C4.80088 10.4911 5.2248 10.6667 5.66683 10.6667H10.3335C10.7755 10.6667 11.1994 10.4911 11.512 10.1785C11.8246 9.86595 12.0002 9.44203 12.0002 9V6.752C12.0002 6.429 11.9219 6.1108 11.7722 5.82461C11.6224 5.53843 11.4056 5.29278 11.1402 5.10867ZM10.6668 9C10.6668 9.08841 10.6317 9.17319 10.5692 9.2357C10.5067 9.29822 10.4219 9.33333 10.3335 9.33333H9.3335V8C9.3335 7.82319 9.26326 7.65362 9.13823 7.5286C9.01321 7.40357 8.84364 7.33333 8.66683 7.33333H7.3335C7.15668 7.33333 6.98712 7.40357 6.86209 7.5286C6.73707 7.65362 6.66683 7.82319 6.66683 8V9.33333H5.66683C5.57842 9.33333 5.49364 9.29822 5.43113 9.2357C5.36861 9.17319 5.3335 9.08841 5.3335 9V6.752C5.33346 6.6443 5.35952 6.53818 5.40944 6.44275C5.45936 6.34731 5.53167 6.26539 5.62016 6.204L7.62016 4.81667C7.73197 4.73978 7.86447 4.69863 8.00016 4.69863C8.13585 4.69863 8.26835 4.73978 8.38016 4.81667L10.3802 6.204C10.4687 6.26539 10.541 6.34731 10.5909 6.44275C10.6408 6.53818 10.6669 6.6443 10.6668 6.752V9Z" fill="#1E1E1E"/>
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_218_3381">
                                            <rect width="16" height="16" fill="white"/>
                                            </clipPath>
                                        </defs>
                                        </svg>
                                        Lease Type : </div><div className='info-value'>{infoDetail.leasetype}</div></div>
                                    <div className='info-row'><div className='info-label'> 
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M13 21L17 3" stroke="#323232" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M7 21L11 3" stroke="#323232" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M20 9L4 9" stroke="#323232" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M4 15L20 15" stroke="#323232" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
                                    Property ID/Tax ID : </div><div className='info-value'>{(infoDetail.prand==1?<b style={{color:"#C42929"}}>{infoDetail.pid}</b>:<>{infoDetail.pid}</>)}</div></div>
                                    <div className='info-row'><div className='info-label'> 
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                    <g clip-path="url(#clip0_218_3379)">
                                        <path d="M8.00037 10.6667C8.31081 10.6673 8.61709 10.5957 8.89503 10.4574L10.2284 9.79074C10.908 9.45331 11.3367 8.75884 11.3337 8.00009V6.02209C11.3361 5.26399 10.9074 4.57043 10.2284 4.23343L8.89503 3.56678C8.33168 3.28678 7.66971 3.28678 7.10637 3.56678L5.77303 4.23343C5.09371 4.57024 4.66481 5.26387 4.66703 6.02209V8.00009C4.66459 8.75837 5.09318 9.45218 5.77237 9.78943L7.10571 10.4561C7.38353 10.5948 7.68984 10.6669 8.00037 10.6667ZM6.00037 8.00009V6.02209C6.00143 5.95409 6.0129 5.88662 6.03437 5.82209L7.48771 6.54875C7.81046 6.71006 8.19031 6.71006 8.51306 6.54875L9.9664 5.82209C9.98787 5.88662 9.99934 5.95409 10.0004 6.02209V8.00009C10.0015 8.25303 9.85843 8.48453 9.63175 8.59674L8.2984 9.2634C8.1104 9.35643 7.88975 9.35643 7.70175 9.2634L6.3684 8.59674C6.14193 8.48434 5.99918 8.2529 6.00037 8.00009ZM12.667 14.6667H10.861L13.1857 12.5187C16.0496 9.65493 16.0497 5.01174 13.1858 2.14784C10.322 -0.716067 5.67887 -0.716099 2.81496 2.14768C-0.0489414 5.01146 -0.0490041 9.65471 2.81481 12.5186C2.82109 12.5249 5.13971 14.6667 5.13971 14.6667H3.33371C2.96553 14.6667 2.66706 14.9652 2.66706 15.3334C2.66706 15.7016 2.96553 16.0001 3.33371 16.0001H12.6671C13.0352 16.0001 13.3337 15.7016 13.3337 15.3334C13.3337 14.9652 13.0352 14.6667 12.667 14.6667ZM3.75771 3.09075C6.09571 0.742245 9.89487 0.733745 12.2434 3.07175C14.5919 5.40975 14.6004 9.2089 12.2624 11.5574L9.60571 14.0114C8.69897 14.8661 7.28178 14.8611 6.38106 14.0001L3.75771 11.5761C1.41818 9.2314 1.41821 5.43543 3.75771 3.09075Z" fill="#1E1E1E"/>
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_218_3379">
                                        <rect width="16" height="16" fill="white"/>
                                        </clipPath>
                                    </defs>
                                    </svg>
                                    Property Address : </div><div className='info-value'>{infoDetail.propertyaddress}, {infoDetail.city}, {infoDetail.state} {infoDetail.zip}</div></div>
                                    <div className='info-row'><div className='info-label'> 
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                    <g clip-path="url(#clip0_218_3382)">
                                        <path d="M8 6.66667C7.46957 6.66667 6.96086 6.45595 6.58579 6.08088C6.21071 5.70581 6 5.1971 6 4.66667C6 4.13623 6.21071 3.62753 6.58579 3.25245C6.96086 2.87738 7.46957 2.66667 8 2.66667C8.53043 2.66667 9.03914 2.87738 9.41421 3.25245C9.78929 3.62753 10 4.13623 10 4.66667C10 5.1971 9.78929 5.70581 9.41421 6.08088C9.03914 6.45595 8.53043 6.66667 8 6.66667ZM5.97867 10.166C6.11576 9.73769 6.38538 9.36401 6.74862 9.09888C7.11187 8.83375 7.54995 8.69087 7.99967 8.69087C8.44938 8.69087 8.88747 8.83375 9.25071 9.09888C9.61396 9.36401 9.88358 9.73769 10.0207 10.166C10.0649 10.3373 10.1753 10.4841 10.3277 10.574C10.4801 10.6639 10.662 10.6895 10.8333 10.6453C11.0047 10.6011 11.1514 10.4907 11.2413 10.3383C11.3312 10.1859 11.3569 10.004 11.3127 9.83267C10.4387 6.53467 5.55933 6.536 4.688 9.83267C4.66393 9.91811 4.65717 10.0075 4.66812 10.0956C4.67906 10.1837 4.70749 10.2687 4.75173 10.3457C4.79597 10.4226 4.85514 10.49 4.92576 10.5438C4.99639 10.5976 5.07704 10.6367 5.16299 10.6589C5.24894 10.6811 5.33846 10.6859 5.4263 10.673C5.51413 10.6602 5.59851 10.6299 5.67449 10.584C5.75047 10.5381 5.81651 10.4775 5.86874 10.4057C5.92098 10.3339 5.95835 10.2524 5.97867 10.166ZM8.006 15.7767C7.6771 15.7769 7.35961 15.6561 7.114 15.4373L4.61533 13.3333H2.66667C1.95942 13.3333 1.28115 13.0524 0.781049 12.5523C0.280952 12.0522 0 11.3739 0 10.6667V2.66667C0 1.95942 0.280952 1.28115 0.781049 0.781049C1.28115 0.280952 1.95942 0 2.66667 0L13.3333 0C14.0406 0 14.7189 0.280952 15.219 0.781049C15.719 1.28115 16 1.95942 16 2.66667V10.6667C16 11.3739 15.719 12.0522 15.219 12.5523C14.7189 13.0524 14.0406 13.3333 13.3333 13.3333H11.4313L8.86667 15.4533C8.62906 15.6629 8.32281 15.7779 8.006 15.7767ZM2.66667 1.33333C2.31304 1.33333 1.97391 1.47381 1.72386 1.72386C1.47381 1.97391 1.33333 2.31304 1.33333 2.66667V10.6667C1.33333 11.0203 1.47381 11.3594 1.72386 11.6095C1.97391 11.8595 2.31304 12 2.66667 12H4.85933C5.01643 12 5.16849 12.0555 5.28867 12.1567L7.986 14.43L10.7673 12.1527C10.8868 12.054 11.037 12 11.192 12H13.3333C13.687 12 14.0261 11.8595 14.2761 11.6095C14.5262 11.3594 14.6667 11.0203 14.6667 10.6667V2.66667C14.6667 2.31304 14.5262 1.97391 14.2761 1.72386C14.0261 1.47381 13.687 1.33333 13.3333 1.33333H2.66667Z" fill="#1E1E1E"/>
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_218_3382">
                                        <rect width="16" height="16" fill="white"/>
                                        </clipPath>
                                    </defs>
                                    </svg>
                                    Agency : </div><div className='info-value'>{infoDetail.agencyname}</div></div>
                                    <div className='info-row'><div className='info-label'> 
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                    <g clip-path="url(#clip0_218_3383)">
                                        <path d="M16.0004 7.98875C15.9989 7.44605 15.8317 6.91673 15.5211 6.47171C15.2105 6.02669 14.7713 5.68721 14.2624 5.49875L14.237 5.43808C13.5757 3.82037 12.3095 2.52434 10.7077 1.82542L10.4884 1.72942C10.2995 1.22203 9.96005 0.784521 9.51545 0.475594C9.07086 0.166668 8.54242 0.00109863 8.00103 0.00109863C7.45964 0.00109863 6.9312 0.166668 6.48661 0.475594C6.04201 0.784521 5.70253 1.22203 5.5137 1.72942L5.23503 1.85475C3.64739 2.57585 2.39783 3.87983 1.74503 5.49675C1.23526 5.68248 0.794677 6.02002 0.482663 6.46387C0.170649 6.90773 0.0022009 7.43657 2.14196e-05 7.97911C-0.00215806 8.52166 0.162036 9.05183 0.470474 9.49818C0.778911 9.94453 1.21677 10.2856 1.72503 10.4754L1.81036 10.6754C2.47926 12.228 3.70772 13.4722 5.2517 14.1608L5.5137 14.2781C5.70306 14.7847 6.04267 15.2215 6.48708 15.5298C6.93148 15.8381 7.45947 16.0034 8.00036 16.0034C8.54126 16.0034 9.06924 15.8381 9.51365 15.5298C9.95805 15.2215 10.2977 14.7847 10.487 14.2781L10.7317 14.1694C12.3467 13.4473 13.6165 12.1237 14.271 10.4801C14.7782 10.2897 15.2154 9.94925 15.5243 9.50419C15.8333 9.05912 15.9993 8.53052 16.0004 7.98875ZM8.00036 1.33342C8.26407 1.33342 8.52186 1.41161 8.74112 1.55812C8.96039 1.70463 9.13128 1.91287 9.2322 2.1565C9.33312 2.40014 9.35952 2.66823 9.30808 2.92687C9.25663 3.18551 9.12964 3.42309 8.94317 3.60956C8.7567 3.79603 8.51912 3.92302 8.26048 3.97446C8.00184 4.02591 7.73375 3.99951 7.49012 3.89859C7.24648 3.79767 7.03824 3.62678 6.89174 3.40751C6.74523 3.18824 6.66703 2.93046 6.66703 2.66675C6.66703 2.31313 6.8075 1.97399 7.05755 1.72394C7.3076 1.47389 7.64674 1.33342 8.00036 1.33342ZM2.65903 6.65675L2.7137 6.67742L2.72036 6.66075C3.05443 6.69064 3.36325 6.851 3.57988 7.10705C3.79652 7.36311 3.9035 7.69423 3.87764 8.02863C3.85178 8.36303 3.69516 8.67376 3.44173 8.89347C3.18831 9.11317 2.8585 9.22414 2.52381 9.20231C2.18912 9.18048 1.87652 9.02762 1.65378 8.77686C1.43104 8.5261 1.3161 8.19766 1.33389 7.86273C1.35168 7.5278 1.50077 7.21338 1.74882 6.98763C1.99687 6.76188 2.32391 6.643 2.65903 6.65675ZM8.00036 14.6668C7.73665 14.6668 7.47887 14.5886 7.2596 14.442C7.04034 14.2955 6.86944 14.0873 6.76852 13.8437C6.66761 13.6 6.6412 13.3319 6.69265 13.0733C6.7441 12.8147 6.87108 12.5771 7.05755 12.3906C7.24402 12.2041 7.4816 12.0772 7.74024 12.0257C7.99888 11.9743 8.26697 12.0007 8.51061 12.1016C8.75424 12.2025 8.96248 12.3734 9.10899 12.5927C9.2555 12.8119 9.3337 13.0697 9.3337 13.3334C9.3337 13.687 9.19322 14.0262 8.94317 14.2762C8.69312 14.5263 8.35398 14.6668 8.00036 14.6668ZM10.5957 12.7428C10.463 12.1534 10.1337 11.6268 9.66195 11.2495C9.19021 10.8722 8.60411 10.6666 8.00003 10.6666C7.39595 10.6666 6.80985 10.8722 6.33811 11.2495C5.86637 11.6268 5.53707 12.1534 5.40436 12.7428C4.49409 12.246 3.74625 11.4975 3.25036 10.5868C3.83784 10.454 4.36289 10.1259 4.73968 9.65601C5.11647 9.18614 5.32269 8.60234 5.32462 8.00006C5.32656 7.39777 5.12409 6.81266 4.75034 6.34037C4.37658 5.86809 3.85364 5.53659 3.26703 5.40008C3.76474 4.50218 4.50552 3.76278 5.40436 3.26675C5.53763 3.85541 5.86708 4.38128 6.33863 4.75801C6.81018 5.13474 7.3958 5.33995 7.99936 5.33995C8.60292 5.33995 9.18855 5.13474 9.6601 4.75801C10.1316 4.38128 10.4611 3.85541 10.5944 3.26675C11.4925 3.76223 12.2337 4.49972 12.7337 5.39542C12.1453 5.52981 11.6201 5.86027 11.2442 6.33255C10.8684 6.80483 10.6643 7.39085 10.6655 7.99441C10.6666 8.59797 10.873 9.18321 11.2506 9.65403C11.6283 10.1249 12.1548 10.4533 12.7437 10.5854C12.2462 11.4933 11.5014 12.2413 10.5957 12.7428ZM13.3337 9.32208C13.07 9.32208 12.8122 9.24389 12.5929 9.09738C12.3737 8.95087 12.2028 8.74263 12.1019 8.49899C12.0009 8.25536 11.9745 7.98727 12.026 7.72863C12.0774 7.46999 12.2044 7.23241 12.3909 7.04594C12.5774 6.85947 12.8149 6.73248 13.0736 6.68104C13.3322 6.62959 13.6003 6.65599 13.8439 6.75691C14.0876 6.85783 14.2958 7.02872 14.4423 7.24799C14.5888 7.46726 14.667 7.72504 14.667 7.98875C14.667 8.34237 14.5266 8.68151 14.2765 8.93156C14.0265 9.18161 13.6873 9.32208 13.3337 9.32208Z" fill="#1E1E1E"/>
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_218_3383">
                                        <rect width="16" height="16" fill="white"/>
                                        </clipPath>
                                    </defs>
                                    </svg>
                                    Sub Lease : </div><div className='info-value'>{(infoDetail.subleaseflag=='N'? 'No':'Yes')  }</div></div>
                                    <div className='info-row'><div className='info-label'> 
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                    <g clip-path="url(#clip0_218_3384)">
                                        <path d="M5.55797 8.8815L7.08222 7.35725L5.55797 5.833C5.2939 5.57797 5.28656 5.15712 5.54162 4.89306C5.79665 4.629 6.2175 4.62166 6.48156 4.87672C6.48709 4.88206 6.49256 4.88753 6.4979 4.89306L8.02215 6.41731L9.5464 4.89306C9.80147 4.629 10.2223 4.62169 10.4863 4.87675C10.7504 5.13181 10.7577 5.55262 10.5027 5.81669C10.4973 5.82222 10.4919 5.82766 10.4863 5.833L8.96209 7.35725L10.4863 8.8815C10.7504 9.13656 10.7577 9.55737 10.5027 9.82144C10.2476 10.0855 9.82678 10.0928 9.56272 9.83775C9.55719 9.83241 9.55175 9.82697 9.5464 9.82144L8.02215 8.29719L6.4979 9.82144C6.23384 10.0765 5.81303 10.0692 5.55797 9.80512C5.30915 9.54753 5.30915 9.13912 5.55797 8.8815ZM2.87043 12.5455C-0.0193475 9.72466 -0.0752223 5.09522 2.74568 2.20541C5.56659 -0.684406 10.196 -0.74025 13.0858 2.08066C13.1217 2.11572 13.1573 2.15116 13.1925 2.18694C16.0479 5.04247 16.0479 9.67206 13.1925 12.5276L10.5388 14.9798C9.13075 16.3436 6.89275 16.338 5.4915 14.9672L2.87043 12.5455ZM2.03953 7.35728C2.03518 8.94484 2.66615 10.4682 3.79178 11.5877L6.40753 14.0046C7.30556 14.8628 8.71812 14.8684 9.62287 14.0172L12.2712 11.5697C14.6026 9.22816 14.5944 5.44 12.2529 3.10859C9.91137 0.777188 6.12322 0.785344 3.79181 3.12687C2.66612 4.24638 2.03518 5.76972 2.03953 7.35728Z" fill="#1E1E1E"/>
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_218_3384">
                                        <rect width="16" height="16" fill="white"/>
                                        </clipPath>
                                    </defs>
                                    </svg>
                                    Terminated Lease : </div><div className='info-value'>{(infoDetail.leaseterminatedflag=='N'?'No':'Yes')  }</div></div>
                                    
                                
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <div style={{height:"250px", width:"450px"}}>
                                    <div>
                                    <MapContainer2 lat={location.lat} lng={location.lng} name={location.name}/>
                                    </div>
                                    
                                    </div>
                                </Grid>
                                
                                <Grid item xs={12} md={12}>
                                    <div>
                                        <div className='info-title'>Building Information</div>
                                        <div className='info-details'>
                                            <Grid container spacing={2}>                                                
                                                <Grid item xs={12} md={3}>
                                                    <div className='info-record-label'>Building ID/L# :</div>
                                                    <div className='info-record-value'> {(infoDetail.brand==1?<b style={{color:"#C42929"}}>{infoDetail.bid}</b>:<>{infoDetail.bid}</>)}</div>
                                                </Grid>
                                                <Grid item xs={12} md={3}>
                                                    <div className='info-record-label'>Key Description:</div>
                                                    <div className='info-record-value'> {
                                                          optionKey.find(opt => opt.ID === infoDetail.pkey)?.value || ""
                                                          }</div>
                                                </Grid>
                                                <Grid item xs={12} md={3}>
                                                    <div className='info-record-label'>Building Location :</div>
                                                    <div className='info-record-value'> {infoDetail.buildinglocation}</div>
                                                </Grid>
                                                
                                                <Grid item xs={12} md={3}>
                                                    <div className='info-record-label'>Ownership :</div>
                                                    <div className='info-record-value'> {infoDetail.ownership}</div>
                                                </Grid>
                                                
                                                <Grid item xs={12} md={3}>
                                                    <div className='info-record-label'>Building Sq.Ft :</div>
                                                    <div className='info-record-value'> {infoDetail.buildingsf}</div>
                                                </Grid>
                                                
                                                <Grid item xs={12} md={3}>
                                                    <div className='info-record-label'>Building Acres :</div>
                                                    <div className='info-record-value'> {infoDetail.buildingacres}</div>
                                                </Grid>
                                                
                                                
                                                <Grid item xs={12} md={3}>
                                                    <div className='info-record-label'>Suites :</div>
                                                    <div className='info-record-value'>
                                                    {Array.isArray(infoDetail.suites) 
                                                        ? infoDetail.suites
                                                            .filter(s => s?.suitenumber)   // remove undefined/null suitenumber
                                                            .map(s => s.suitenumber)       // extract the suite numbers
                                                            .join(", ")                    // join with comma
                                                        : ""
                                                    }
                                                    </div>
                                                </Grid>
                                                
                                            </Grid>
                                            
                                        </div>
                                    </div>
                                </Grid>
                               
                               
                                
                                <Grid item xs={12} md={12}>
                                    <div>
                                        <div className='info-title'>Tenant Information</div>
                                        <div className='info-details'>
                                            <div className='info-col'>
                                                <div className='info-svg'><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><g clip-path="url(#clip0_218_3356)"><path d="M12 12C13.1867 12 14.3467 11.6481 15.3334 10.9888C16.3201 10.3295 17.0892 9.39246 17.5433 8.2961C17.9974 7.19975 18.1162 5.99335 17.8847 4.82946C17.6532 3.66558 17.0818 2.59648 16.2426 1.75736C15.4035 0.918247 14.3344 0.346802 13.1705 0.115291C12.0067 -0.11622 10.8003 0.00259972 9.7039 0.456726C8.60754 0.910851 7.67047 1.67989 7.01118 2.66658C6.35189 3.65328 6 4.81331 6 6C6.00159 7.59081 6.63424 9.11602 7.75911 10.2409C8.88399 11.3658 10.4092 11.9984 12 12ZM12 2C12.7911 2 13.5645 2.2346 14.2223 2.67412C14.8801 3.11365 15.3928 3.73836 15.6955 4.46927C15.9983 5.20017 16.0775 6.00444 15.9231 6.78036C15.7688 7.55629 15.3878 8.26902 14.8284 8.82843C14.269 9.38784 13.5563 9.7688 12.7804 9.92314C12.0044 10.0775 11.2002 9.99827 10.4693 9.69552C9.73836 9.39277 9.11365 8.88008 8.67412 8.22228C8.2346 7.56449 8 6.79113 8 6C8 4.93914 8.42143 3.92172 9.17157 3.17158C9.92172 2.42143 10.9391 2 12 2Z" fill="#1E1E1E"/><path d="M12 14.0005C9.61386 14.0031 7.32622 14.9522 5.63896 16.6395C3.95171 18.3267 3.00265 20.6144 3 23.0005C3 23.2657 3.10536 23.5201 3.29289 23.7076C3.48043 23.8951 3.73478 24.0005 4 24.0005C4.26522 24.0005 4.51957 23.8951 4.70711 23.7076C4.89464 23.5201 5 23.2657 5 23.0005C5 21.144 5.7375 19.3635 7.05025 18.0507C8.36301 16.738 10.1435 16.0005 12 16.0005C13.8565 16.0005 15.637 16.738 16.9497 18.0507C18.2625 19.3635 19 21.144 19 23.0005C19 23.2657 19.1054 23.5201 19.2929 23.7076C19.4804 23.8951 19.7348 24.0005 20 24.0005C20.2652 24.0005 20.5196 23.8951 20.7071 23.7076C20.8946 23.5201 21 23.2657 21 23.0005C20.9974 20.6144 20.0483 18.3267 18.361 16.6395C16.6738 14.9522 14.3861 14.0031 12 14.0005Z" fill="#1E1E1E"/></g><defs><clipPath id="clip0_218_3356"><rect width="24" height="24" fill="white"/></clipPath></defs></svg></div>
                                                <div className='info-record'>
                                                    <div className='info-record-label'>Name :</div>
                                                    <div className='info-record-value'>{infoDetail.tenantcontactname}</div>
                                                </div>
                                            </div>
                                            <div className='info-col'>
                                                <div className='info-svg'><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                    <g clip-path="url(#clip0_220_3494)">
                                                        <path d="M13 1.00013C13 0.734916 13.1053 0.480562 13.2929 0.293025C13.4804 0.105489 13.7348 0.000132124 14 0.000132124C16.6512 0.00304372 19.1931 1.05755 21.0678 2.93228C22.9425 4.80701 23.997 7.34886 24 10.0001C24 10.2654 23.8946 10.5197 23.7071 10.7072C23.5195 10.8948 23.2652 11.0001 23 11.0001C22.7347 11.0001 22.4804 10.8948 22.2929 10.7072C22.1053 10.5197 22 10.2654 22 10.0001C21.9976 7.87913 21.154 5.84568 19.6542 4.34591C18.1544 2.84613 16.121 2.00251 14 2.00013C13.7348 2.00013 13.4804 1.89478 13.2929 1.70724C13.1053 1.5197 13 1.26535 13 1.00013ZM14 6.00013C15.0608 6.00013 16.0782 6.42156 16.8284 7.17171C17.5785 7.92185 18 8.93927 18 10.0001C18 10.2654 18.1053 10.5197 18.2929 10.7072C18.4804 10.8948 18.7347 11.0001 19 11.0001C19.2652 11.0001 19.5195 10.8948 19.7071 10.7072C19.8946 10.5197 20 10.2654 20 10.0001C19.9984 8.40932 19.3657 6.88412 18.2409 5.75925C17.116 4.63437 15.5908 4.00172 14 4.00013C13.7348 4.00013 13.4804 4.10549 13.2929 4.29303C13.1053 4.48056 13 4.73492 13 5.00013C13 5.26535 13.1053 5.5197 13.2929 5.70724C13.4804 5.89478 13.7348 6.00013 14 6.00013ZM23.093 16.7391C23.6725 17.3202 23.9979 18.1074 23.9979 18.9281C23.9979 19.7488 23.6725 20.536 23.093 21.1171L22.183 22.1661C13.993 30.0071 -5.93701 10.0821 1.78298 1.86613L2.93298 0.866132C3.51475 0.302809 4.29491 -0.0088188 5.10468 -0.00133303C5.91445 0.00615273 6.68872 0.332151 7.25998 0.906132C7.29098 0.937132 9.14398 3.34413 9.14398 3.34413C9.6938 3.92176 9.99988 4.68906 9.99858 5.48654C9.99727 6.28401 9.68869 7.05031 9.13698 7.62613L7.97898 9.08213C8.61982 10.6392 9.56204 12.0544 10.7515 13.2462C11.9409 14.4381 13.3542 15.3831 14.91 16.0271L16.375 14.8621C16.9509 14.3108 17.717 14.0026 18.5143 14.0015C19.3115 14.0004 20.0785 14.3065 20.656 14.8561C20.656 14.8561 23.062 16.7081 23.093 16.7391ZM21.717 18.1931C21.717 18.1931 19.324 16.3521 19.293 16.3211C19.0869 16.1169 18.8086 16.0023 18.5185 16.0023C18.2283 16.0023 17.95 16.1169 17.744 16.3211C17.717 16.3491 15.7 17.9561 15.7 17.9561C15.564 18.0643 15.4023 18.1352 15.2306 18.1619C15.0589 18.1885 14.8833 18.17 14.721 18.1081C12.7054 17.3577 10.8747 16.1829 9.35281 14.6632C7.83091 13.1436 6.65338 11.3146 5.89998 9.30013C5.83318 9.13559 5.8114 8.95622 5.83688 8.78047C5.86237 8.60472 5.93419 8.43893 6.04498 8.30013C6.04498 8.30013 7.65198 6.28213 7.67898 6.25613C7.88324 6.05012 7.99786 5.77175 7.99786 5.48163C7.99786 5.19152 7.88324 4.91315 7.67898 4.70713C7.64798 4.67713 5.80698 2.28213 5.80698 2.28213C5.59788 2.09464 5.32498 1.99423 5.04423 2.00148C4.76347 2.00873 4.49612 2.1231 4.29698 2.32113L3.14698 3.32113C-2.49501 10.1051 14.776 26.4181 20.721 20.8001L21.632 19.7501C21.8454 19.5524 21.9737 19.2794 21.9895 18.9888C22.0054 18.6983 21.9076 18.4129 21.717 18.1931Z" fill="#1E1E1E"/>
                                                    </g>
                                                    <defs>
                                                        <clipPath id="clip0_220_3494">
                                                        <rect width="24" height="24" fill="white"/>
                                                        </clipPath>
                                                    </defs>
                                                    </svg></div>
                                                <div className='info-record'>
                                                    <div className='info-record-label'>Contact 1 :</div>
                                                    <div className='info-record-value'>{infoDetail.tenantcontactphone1}</div>
                                                </div>
                                            </div>
                                            <div className='info-col'>
                                                <div className='info-svg'><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                <g clip-path="url(#clip0_218_3354)">
                                                    <path d="M13 1.00013C13 0.734916 13.1053 0.480562 13.2929 0.293025C13.4804 0.105489 13.7348 0.000132124 14 0.000132124C16.6512 0.00304372 19.1931 1.05755 21.0678 2.93228C22.9425 4.80701 23.997 7.34886 24 10.0001C24 10.2654 23.8946 10.5197 23.7071 10.7072C23.5195 10.8948 23.2652 11.0001 23 11.0001C22.7347 11.0001 22.4804 10.8948 22.2929 10.7072C22.1053 10.5197 22 10.2654 22 10.0001C21.9976 7.87913 21.154 5.84568 19.6542 4.34591C18.1544 2.84613 16.121 2.00251 14 2.00013C13.7348 2.00013 13.4804 1.89478 13.2929 1.70724C13.1053 1.5197 13 1.26535 13 1.00013ZM14 6.00013C15.0608 6.00013 16.0782 6.42156 16.8284 7.17171C17.5785 7.92185 18 8.93927 18 10.0001C18 10.2654 18.1053 10.5197 18.2929 10.7072C18.4804 10.8948 18.7347 11.0001 19 11.0001C19.2652 11.0001 19.5195 10.8948 19.7071 10.7072C19.8946 10.5197 20 10.2654 20 10.0001C19.9984 8.40932 19.3657 6.88412 18.2409 5.75925C17.116 4.63437 15.5908 4.00172 14 4.00013C13.7348 4.00013 13.4804 4.10549 13.2929 4.29303C13.1053 4.48056 13 4.73492 13 5.00013C13 5.26535 13.1053 5.5197 13.2929 5.70724C13.4804 5.89478 13.7348 6.00013 14 6.00013ZM23.093 16.7391C23.6725 17.3202 23.9979 18.1074 23.9979 18.9281C23.9979 19.7488 23.6725 20.536 23.093 21.1171L22.183 22.1661C13.993 30.0071 -5.93701 10.0821 1.78298 1.86613L2.93298 0.866132C3.51475 0.302809 4.29491 -0.0088188 5.10468 -0.00133303C5.91445 0.00615273 6.68872 0.332151 7.25998 0.906132C7.29098 0.937132 9.14398 3.34413 9.14398 3.34413C9.6938 3.92176 9.99988 4.68906 9.99858 5.48654C9.99727 6.28401 9.68869 7.05031 9.13698 7.62613L7.97898 9.08213C8.61982 10.6392 9.56204 12.0544 10.7515 13.2462C11.9409 14.4381 13.3542 15.3831 14.91 16.0271L16.375 14.8621C16.9509 14.3108 17.717 14.0026 18.5143 14.0015C19.3115 14.0004 20.0785 14.3065 20.656 14.8561C20.656 14.8561 23.062 16.7081 23.093 16.7391ZM21.717 18.1931C21.717 18.1931 19.324 16.3521 19.293 16.3211C19.0869 16.1169 18.8086 16.0023 18.5185 16.0023C18.2283 16.0023 17.95 16.1169 17.744 16.3211C17.717 16.3491 15.7 17.9561 15.7 17.9561C15.564 18.0643 15.4023 18.1352 15.2306 18.1619C15.0589 18.1885 14.8833 18.17 14.721 18.1081C12.7054 17.3577 10.8747 16.1829 9.35281 14.6632C7.83091 13.1436 6.65338 11.3146 5.89998 9.30013C5.83318 9.13559 5.8114 8.95622 5.83688 8.78047C5.86237 8.60472 5.93419 8.43893 6.04498 8.30013C6.04498 8.30013 7.65198 6.28213 7.67898 6.25613C7.88324 6.05012 7.99786 5.77175 7.99786 5.48163C7.99786 5.19152 7.88324 4.91315 7.67898 4.70713C7.64798 4.67713 5.80698 2.28213 5.80698 2.28213C5.59788 2.09464 5.32498 1.99423 5.04423 2.00148C4.76347 2.00873 4.49612 2.1231 4.29698 2.32113L3.14698 3.32113C-2.49501 10.1051 14.776 26.4181 20.721 20.8001L21.632 19.7501C21.8454 19.5524 21.9737 19.2794 21.9895 18.9888C22.0054 18.6983 21.9076 18.4129 21.717 18.1931Z" fill="#1E1E1E"/>
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_218_3354">
                                                    <rect width="24" height="24" fill="white"/>
                                                    </clipPath>
                                                </defs>
                                                </svg></div>
                                                <div className='info-record'>
                                                    <div className='info-record-label'>Contact 2 :</div>
                                                    <div className='info-record-value'>{infoDetail.tenantcontactphone2}</div>
                                                </div>
                                            </div>
                                            <div className='info-col'>
                                                <div className='info-svg'><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                            <g clip-path="url(#clip0_220_3496)">
                                                                <path d="M19 0.999756H5C3.67441 1.00134 2.40356 1.52864 1.46622 2.46598C0.528882 3.40331 0.00158786 4.67416 0 5.99976L0 17.9998C0.00158786 19.3254 0.528882 20.5962 1.46622 21.5335C2.40356 22.4709 3.67441 22.9982 5 22.9998H19C20.3256 22.9982 21.5964 22.4709 22.5338 21.5335C23.4711 20.5962 23.9984 19.3254 24 17.9998V5.99976C23.9984 4.67416 23.4711 3.40331 22.5338 2.46598C21.5964 1.52864 20.3256 1.00134 19 0.999756ZM5 2.99976H19C19.5988 3.00093 20.1835 3.18127 20.679 3.51756C21.1744 3.85385 21.5579 4.3307 21.78 4.88676L14.122 12.5458C13.5584 13.1071 12.7954 13.4222 12 13.4222C11.2046 13.4222 10.4416 13.1071 9.878 12.5458L2.22 4.88676C2.44215 4.3307 2.82561 3.85385 3.32105 3.51756C3.81648 3.18127 4.40121 3.00093 5 2.99976ZM19 20.9998H5C4.20435 20.9998 3.44129 20.6837 2.87868 20.1211C2.31607 19.5585 2 18.7954 2 17.9998V7.49976L8.464 13.9598C9.40263 14.896 10.6743 15.4218 12 15.4218C13.3257 15.4218 14.5974 14.896 15.536 13.9598L22 7.49976V17.9998C22 18.7954 21.6839 19.5585 21.1213 20.1211C20.5587 20.6837 19.7956 20.9998 19 20.9998Z" fill="#1E1E1E"/>
                                                            </g>
                                                            <defs>
                                                                <clipPath id="clip0_220_3496">
                                                                <rect width="24" height="24" fill="white"/>
                                                                </clipPath>
                                                            </defs>
                                                            </svg></div>
                                                <div className='info-record'>
                                                    <div className='info-record-label'>Email 1 :</div>
                                                    <div className='info-record-value'>{infoDetail.tenantcontactemail1}</div>
                                                </div>
                                            </div>
                                            <div className='info-col'>
                                                <div className='info-svg'><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                    <g clip-path="url(#clip0_220_3496)">
                                                        <path d="M19 0.999756H5C3.67441 1.00134 2.40356 1.52864 1.46622 2.46598C0.528882 3.40331 0.00158786 4.67416 0 5.99976L0 17.9998C0.00158786 19.3254 0.528882 20.5962 1.46622 21.5335C2.40356 22.4709 3.67441 22.9982 5 22.9998H19C20.3256 22.9982 21.5964 22.4709 22.5338 21.5335C23.4711 20.5962 23.9984 19.3254 24 17.9998V5.99976C23.9984 4.67416 23.4711 3.40331 22.5338 2.46598C21.5964 1.52864 20.3256 1.00134 19 0.999756ZM5 2.99976H19C19.5988 3.00093 20.1835 3.18127 20.679 3.51756C21.1744 3.85385 21.5579 4.3307 21.78 4.88676L14.122 12.5458C13.5584 13.1071 12.7954 13.4222 12 13.4222C11.2046 13.4222 10.4416 13.1071 9.878 12.5458L2.22 4.88676C2.44215 4.3307 2.82561 3.85385 3.32105 3.51756C3.81648 3.18127 4.40121 3.00093 5 2.99976ZM19 20.9998H5C4.20435 20.9998 3.44129 20.6837 2.87868 20.1211C2.31607 19.5585 2 18.7954 2 17.9998V7.49976L8.464 13.9598C9.40263 14.896 10.6743 15.4218 12 15.4218C13.3257 15.4218 14.5974 14.896 15.536 13.9598L22 7.49976V17.9998C22 18.7954 21.6839 19.5585 21.1213 20.1211C20.5587 20.6837 19.7956 20.9998 19 20.9998Z" fill="#1E1E1E"/>
                                                    </g>
                                                    <defs>
                                                        <clipPath id="clip0_220_3496">
                                                        <rect width="24" height="24" fill="white"/>
                                                        </clipPath>
                                                    </defs>
                                                    </svg></div>
                                                <div className='info-record'>
                                                    <div className='info-record-label'>Email 2 :</div>
                                                    <div className='info-record-value'>{infoDetail.tenantcontactemail2}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Grid>
                                <Grid item xs={12} md={12}>
                                    <div>
                                        <div className='info-title'>Landlord Information</div>
                                        <div className='info-details'>
                                            <div className='info-col'>
                                                <div className='info-svg'><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><g clip-path="url(#clip0_218_3356)"><path d="M12 12C13.1867 12 14.3467 11.6481 15.3334 10.9888C16.3201 10.3295 17.0892 9.39246 17.5433 8.2961C17.9974 7.19975 18.1162 5.99335 17.8847 4.82946C17.6532 3.66558 17.0818 2.59648 16.2426 1.75736C15.4035 0.918247 14.3344 0.346802 13.1705 0.115291C12.0067 -0.11622 10.8003 0.00259972 9.7039 0.456726C8.60754 0.910851 7.67047 1.67989 7.01118 2.66658C6.35189 3.65328 6 4.81331 6 6C6.00159 7.59081 6.63424 9.11602 7.75911 10.2409C8.88399 11.3658 10.4092 11.9984 12 12ZM12 2C12.7911 2 13.5645 2.2346 14.2223 2.67412C14.8801 3.11365 15.3928 3.73836 15.6955 4.46927C15.9983 5.20017 16.0775 6.00444 15.9231 6.78036C15.7688 7.55629 15.3878 8.26902 14.8284 8.82843C14.269 9.38784 13.5563 9.7688 12.7804 9.92314C12.0044 10.0775 11.2002 9.99827 10.4693 9.69552C9.73836 9.39277 9.11365 8.88008 8.67412 8.22228C8.2346 7.56449 8 6.79113 8 6C8 4.93914 8.42143 3.92172 9.17157 3.17158C9.92172 2.42143 10.9391 2 12 2Z" fill="#1E1E1E"/><path d="M12 14.0005C9.61386 14.0031 7.32622 14.9522 5.63896 16.6395C3.95171 18.3267 3.00265 20.6144 3 23.0005C3 23.2657 3.10536 23.5201 3.29289 23.7076C3.48043 23.8951 3.73478 24.0005 4 24.0005C4.26522 24.0005 4.51957 23.8951 4.70711 23.7076C4.89464 23.5201 5 23.2657 5 23.0005C5 21.144 5.7375 19.3635 7.05025 18.0507C8.36301 16.738 10.1435 16.0005 12 16.0005C13.8565 16.0005 15.637 16.738 16.9497 18.0507C18.2625 19.3635 19 21.144 19 23.0005C19 23.2657 19.1054 23.5201 19.2929 23.7076C19.4804 23.8951 19.7348 24.0005 20 24.0005C20.2652 24.0005 20.5196 23.8951 20.7071 23.7076C20.8946 23.5201 21 23.2657 21 23.0005C20.9974 20.6144 20.0483 18.3267 18.361 16.6395C16.6738 14.9522 14.3861 14.0031 12 14.0005Z" fill="#1E1E1E"/></g><defs><clipPath id="clip0_218_3356"><rect width="24" height="24" fill="white"/></clipPath></defs></svg></div>
                                                <div className='info-record'>
                                                    <div className='info-record-label'>Name :</div>
                                                    <div className='info-record-value'>{infoDetail.landlordname}</div>
                                                </div>
                                            </div>
                                            <div className='info-col'>
                                                <div className='info-svg'><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                                <g clip-path="url(#clip0_220_3494)">
                                                                    <path d="M13 1.00013C13 0.734916 13.1053 0.480562 13.2929 0.293025C13.4804 0.105489 13.7348 0.000132124 14 0.000132124C16.6512 0.00304372 19.1931 1.05755 21.0678 2.93228C22.9425 4.80701 23.997 7.34886 24 10.0001C24 10.2654 23.8946 10.5197 23.7071 10.7072C23.5195 10.8948 23.2652 11.0001 23 11.0001C22.7347 11.0001 22.4804 10.8948 22.2929 10.7072C22.1053 10.5197 22 10.2654 22 10.0001C21.9976 7.87913 21.154 5.84568 19.6542 4.34591C18.1544 2.84613 16.121 2.00251 14 2.00013C13.7348 2.00013 13.4804 1.89478 13.2929 1.70724C13.1053 1.5197 13 1.26535 13 1.00013ZM14 6.00013C15.0608 6.00013 16.0782 6.42156 16.8284 7.17171C17.5785 7.92185 18 8.93927 18 10.0001C18 10.2654 18.1053 10.5197 18.2929 10.7072C18.4804 10.8948 18.7347 11.0001 19 11.0001C19.2652 11.0001 19.5195 10.8948 19.7071 10.7072C19.8946 10.5197 20 10.2654 20 10.0001C19.9984 8.40932 19.3657 6.88412 18.2409 5.75925C17.116 4.63437 15.5908 4.00172 14 4.00013C13.7348 4.00013 13.4804 4.10549 13.2929 4.29303C13.1053 4.48056 13 4.73492 13 5.00013C13 5.26535 13.1053 5.5197 13.2929 5.70724C13.4804 5.89478 13.7348 6.00013 14 6.00013ZM23.093 16.7391C23.6725 17.3202 23.9979 18.1074 23.9979 18.9281C23.9979 19.7488 23.6725 20.536 23.093 21.1171L22.183 22.1661C13.993 30.0071 -5.93701 10.0821 1.78298 1.86613L2.93298 0.866132C3.51475 0.302809 4.29491 -0.0088188 5.10468 -0.00133303C5.91445 0.00615273 6.68872 0.332151 7.25998 0.906132C7.29098 0.937132 9.14398 3.34413 9.14398 3.34413C9.6938 3.92176 9.99988 4.68906 9.99858 5.48654C9.99727 6.28401 9.68869 7.05031 9.13698 7.62613L7.97898 9.08213C8.61982 10.6392 9.56204 12.0544 10.7515 13.2462C11.9409 14.4381 13.3542 15.3831 14.91 16.0271L16.375 14.8621C16.9509 14.3108 17.717 14.0026 18.5143 14.0015C19.3115 14.0004 20.0785 14.3065 20.656 14.8561C20.656 14.8561 23.062 16.7081 23.093 16.7391ZM21.717 18.1931C21.717 18.1931 19.324 16.3521 19.293 16.3211C19.0869 16.1169 18.8086 16.0023 18.5185 16.0023C18.2283 16.0023 17.95 16.1169 17.744 16.3211C17.717 16.3491 15.7 17.9561 15.7 17.9561C15.564 18.0643 15.4023 18.1352 15.2306 18.1619C15.0589 18.1885 14.8833 18.17 14.721 18.1081C12.7054 17.3577 10.8747 16.1829 9.35281 14.6632C7.83091 13.1436 6.65338 11.3146 5.89998 9.30013C5.83318 9.13559 5.8114 8.95622 5.83688 8.78047C5.86237 8.60472 5.93419 8.43893 6.04498 8.30013C6.04498 8.30013 7.65198 6.28213 7.67898 6.25613C7.88324 6.05012 7.99786 5.77175 7.99786 5.48163C7.99786 5.19152 7.88324 4.91315 7.67898 4.70713C7.64798 4.67713 5.80698 2.28213 5.80698 2.28213C5.59788 2.09464 5.32498 1.99423 5.04423 2.00148C4.76347 2.00873 4.49612 2.1231 4.29698 2.32113L3.14698 3.32113C-2.49501 10.1051 14.776 26.4181 20.721 20.8001L21.632 19.7501C21.8454 19.5524 21.9737 19.2794 21.9895 18.9888C22.0054 18.6983 21.9076 18.4129 21.717 18.1931Z" fill="#1E1E1E"/>
                                                                </g>
                                                                <defs>
                                                                    <clipPath id="clip0_220_3494">
                                                                    <rect width="24" height="24" fill="white"/>
                                                                    </clipPath>
                                                                </defs>
                                                                </svg></div>
                                                <div className='info-record'>
                                                    <div className='info-record-label'>Contact 1 :</div>
                                                    <div className='info-record-value'>{infoDetail.landlordphone1}</div>
                                                </div>
                                            </div>
                                            <div className='info-col'>
                                                <div className='info-svg'><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                        <g clip-path="url(#clip0_218_3354)">
                                                            <path d="M13 1.00013C13 0.734916 13.1053 0.480562 13.2929 0.293025C13.4804 0.105489 13.7348 0.000132124 14 0.000132124C16.6512 0.00304372 19.1931 1.05755 21.0678 2.93228C22.9425 4.80701 23.997 7.34886 24 10.0001C24 10.2654 23.8946 10.5197 23.7071 10.7072C23.5195 10.8948 23.2652 11.0001 23 11.0001C22.7347 11.0001 22.4804 10.8948 22.2929 10.7072C22.1053 10.5197 22 10.2654 22 10.0001C21.9976 7.87913 21.154 5.84568 19.6542 4.34591C18.1544 2.84613 16.121 2.00251 14 2.00013C13.7348 2.00013 13.4804 1.89478 13.2929 1.70724C13.1053 1.5197 13 1.26535 13 1.00013ZM14 6.00013C15.0608 6.00013 16.0782 6.42156 16.8284 7.17171C17.5785 7.92185 18 8.93927 18 10.0001C18 10.2654 18.1053 10.5197 18.2929 10.7072C18.4804 10.8948 18.7347 11.0001 19 11.0001C19.2652 11.0001 19.5195 10.8948 19.7071 10.7072C19.8946 10.5197 20 10.2654 20 10.0001C19.9984 8.40932 19.3657 6.88412 18.2409 5.75925C17.116 4.63437 15.5908 4.00172 14 4.00013C13.7348 4.00013 13.4804 4.10549 13.2929 4.29303C13.1053 4.48056 13 4.73492 13 5.00013C13 5.26535 13.1053 5.5197 13.2929 5.70724C13.4804 5.89478 13.7348 6.00013 14 6.00013ZM23.093 16.7391C23.6725 17.3202 23.9979 18.1074 23.9979 18.9281C23.9979 19.7488 23.6725 20.536 23.093 21.1171L22.183 22.1661C13.993 30.0071 -5.93701 10.0821 1.78298 1.86613L2.93298 0.866132C3.51475 0.302809 4.29491 -0.0088188 5.10468 -0.00133303C5.91445 0.00615273 6.68872 0.332151 7.25998 0.906132C7.29098 0.937132 9.14398 3.34413 9.14398 3.34413C9.6938 3.92176 9.99988 4.68906 9.99858 5.48654C9.99727 6.28401 9.68869 7.05031 9.13698 7.62613L7.97898 9.08213C8.61982 10.6392 9.56204 12.0544 10.7515 13.2462C11.9409 14.4381 13.3542 15.3831 14.91 16.0271L16.375 14.8621C16.9509 14.3108 17.717 14.0026 18.5143 14.0015C19.3115 14.0004 20.0785 14.3065 20.656 14.8561C20.656 14.8561 23.062 16.7081 23.093 16.7391ZM21.717 18.1931C21.717 18.1931 19.324 16.3521 19.293 16.3211C19.0869 16.1169 18.8086 16.0023 18.5185 16.0023C18.2283 16.0023 17.95 16.1169 17.744 16.3211C17.717 16.3491 15.7 17.9561 15.7 17.9561C15.564 18.0643 15.4023 18.1352 15.2306 18.1619C15.0589 18.1885 14.8833 18.17 14.721 18.1081C12.7054 17.3577 10.8747 16.1829 9.35281 14.6632C7.83091 13.1436 6.65338 11.3146 5.89998 9.30013C5.83318 9.13559 5.8114 8.95622 5.83688 8.78047C5.86237 8.60472 5.93419 8.43893 6.04498 8.30013C6.04498 8.30013 7.65198 6.28213 7.67898 6.25613C7.88324 6.05012 7.99786 5.77175 7.99786 5.48163C7.99786 5.19152 7.88324 4.91315 7.67898 4.70713C7.64798 4.67713 5.80698 2.28213 5.80698 2.28213C5.59788 2.09464 5.32498 1.99423 5.04423 2.00148C4.76347 2.00873 4.49612 2.1231 4.29698 2.32113L3.14698 3.32113C-2.49501 10.1051 14.776 26.4181 20.721 20.8001L21.632 19.7501C21.8454 19.5524 21.9737 19.2794 21.9895 18.9888C22.0054 18.6983 21.9076 18.4129 21.717 18.1931Z" fill="#1E1E1E"/>
                                                        </g>
                                                        <defs>
                                                            <clipPath id="clip0_218_3354">
                                                            <rect width="24" height="24" fill="white"/>
                                                            </clipPath>
                                                        </defs>
                                                        </svg></div>
                                                <div className='info-record'>
                                                    <div className='info-record-label'>Contact 2 :</div>
                                                    <div className='info-record-value'>{infoDetail.landlordphone2}</div>
                                                </div>
                                            </div>
                                            <div className='info-col'>
                                                <div className='info-svg'><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                                    <g clip-path="url(#clip0_220_3496)">
                                                                        <path d="M19 0.999756H5C3.67441 1.00134 2.40356 1.52864 1.46622 2.46598C0.528882 3.40331 0.00158786 4.67416 0 5.99976L0 17.9998C0.00158786 19.3254 0.528882 20.5962 1.46622 21.5335C2.40356 22.4709 3.67441 22.9982 5 22.9998H19C20.3256 22.9982 21.5964 22.4709 22.5338 21.5335C23.4711 20.5962 23.9984 19.3254 24 17.9998V5.99976C23.9984 4.67416 23.4711 3.40331 22.5338 2.46598C21.5964 1.52864 20.3256 1.00134 19 0.999756ZM5 2.99976H19C19.5988 3.00093 20.1835 3.18127 20.679 3.51756C21.1744 3.85385 21.5579 4.3307 21.78 4.88676L14.122 12.5458C13.5584 13.1071 12.7954 13.4222 12 13.4222C11.2046 13.4222 10.4416 13.1071 9.878 12.5458L2.22 4.88676C2.44215 4.3307 2.82561 3.85385 3.32105 3.51756C3.81648 3.18127 4.40121 3.00093 5 2.99976ZM19 20.9998H5C4.20435 20.9998 3.44129 20.6837 2.87868 20.1211C2.31607 19.5585 2 18.7954 2 17.9998V7.49976L8.464 13.9598C9.40263 14.896 10.6743 15.4218 12 15.4218C13.3257 15.4218 14.5974 14.896 15.536 13.9598L22 7.49976V17.9998C22 18.7954 21.6839 19.5585 21.1213 20.1211C20.5587 20.6837 19.7956 20.9998 19 20.9998Z" fill="#1E1E1E"/>
                                                                    </g>
                                                                    <defs>
                                                                        <clipPath id="clip0_220_3496">
                                                                        <rect width="24" height="24" fill="white"/>
                                                                        </clipPath>
                                                                    </defs>
                                                                    </svg></div>
                                                <div className='info-record'>
                                                    <div className='info-record-label'>Email 1 :</div>
                                                    <div className='info-record-value'>{infoDetail.landlordemail1}</div>
                                                </div>
                                            </div>
                                            <div className='info-col'>
                                                <div className='info-svg'><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                        <g clip-path="url(#clip0_220_3496)">
                                                            <path d="M19 0.999756H5C3.67441 1.00134 2.40356 1.52864 1.46622 2.46598C0.528882 3.40331 0.00158786 4.67416 0 5.99976L0 17.9998C0.00158786 19.3254 0.528882 20.5962 1.46622 21.5335C2.40356 22.4709 3.67441 22.9982 5 22.9998H19C20.3256 22.9982 21.5964 22.4709 22.5338 21.5335C23.4711 20.5962 23.9984 19.3254 24 17.9998V5.99976C23.9984 4.67416 23.4711 3.40331 22.5338 2.46598C21.5964 1.52864 20.3256 1.00134 19 0.999756ZM5 2.99976H19C19.5988 3.00093 20.1835 3.18127 20.679 3.51756C21.1744 3.85385 21.5579 4.3307 21.78 4.88676L14.122 12.5458C13.5584 13.1071 12.7954 13.4222 12 13.4222C11.2046 13.4222 10.4416 13.1071 9.878 12.5458L2.22 4.88676C2.44215 4.3307 2.82561 3.85385 3.32105 3.51756C3.81648 3.18127 4.40121 3.00093 5 2.99976ZM19 20.9998H5C4.20435 20.9998 3.44129 20.6837 2.87868 20.1211C2.31607 19.5585 2 18.7954 2 17.9998V7.49976L8.464 13.9598C9.40263 14.896 10.6743 15.4218 12 15.4218C13.3257 15.4218 14.5974 14.896 15.536 13.9598L22 7.49976V17.9998C22 18.7954 21.6839 19.5585 21.1213 20.1211C20.5587 20.6837 19.7956 20.9998 19 20.9998Z" fill="#1E1E1E"/>
                                                        </g>
                                                        <defs>
                                                            <clipPath id="clip0_220_3496">
                                                            <rect width="24" height="24" fill="white"/>
                                                            </clipPath>
                                                        </defs>
                                                        </svg></div>
                                                <div className='info-record'>
                                                    <div className='info-record-label'>Email 2 :</div>
                                                    <div className='info-record-value'>{infoDetail.landlordemail2}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Grid>
                                
                                <Grid item xs={12} md={12}>
                                    <div>
                                        <div className='info-title'>Lease Snapshots</div>
                                        <div className='info-details'>
                                        <Grid container spacing={2}>
                                                
                                                 <Grid item xs={12} md={3}>
                                                    <div className='info-record-label'>Lease ID :</div>
                                                    <div className='info-record-value'>{(infoDetail.brand==1?<b style={{color:"#C42929"}}>{infoDetail.lnumber}</b>:<>{infoDetail.lnumber}</>)}</div>
                                                </Grid>
                                                
                                                 <Grid item xs={12} md={3}>
                                                    <div className='info-record-label'>Agreement Type :</div>
                                                    <div className='info-record-value'>{(infoDetail.agreement)}</div>
                                                </Grid>
                                                 <Grid item xs={12} md={3}>
                                                    <div className='info-record-label'>Lease SQ.FT :</div>
                                                    <div className='info-record-value'>{(infoDetail.areasf)}</div>
                                                </Grid>
                                                 <Grid item xs={12} md={3}>
                                                    <div className='info-record-label'>Commence Date:</div>
                                                    <div className='info-record-value'>{convert_date(infoDetail.commence_date)}</div>
                                                </Grid>
                                                <Grid item xs={12} md={3}>
                                                    <div className='info-record-label'>Expiration Date:</div>
                                                    <div className='info-record-value'>{convert_date(infoDetail.expiration_date)}</div>
                                                </Grid>
                                                {infoDetail.rental_commence_date && (
                                                 <Grid item xs={12} md={3}>
                                                    <div className='info-record-label'>Rental Commence Date:</div>
                                                    <div className='info-record-value'>{convert_date(infoDetail.rental_commence_date)}</div>
                                                </Grid>
                                                )}
                                                
                                                {/* 
                                                <Grid item xs={12} md={3}>
                                                    <div className='info-record-label'>Operating Expense :</div>
                                                    <div className='info-record-value'>{(infoDetail.monthlyrentcam?'$ '+parseFloat((infoDetail.monthlyrentcam*12).toFixed(2)).toLocaleString():'')}</div>
                                                </Grid>
                                                <Grid item xs={12} md={3}>
                                                    <div className='info-record-label'>Other Expense :</div>
                                                    <div className='info-record-value'>{(infoDetail.monthlyrentother?'$ '+parseFloat((infoDetail.monthlyrentother*12).toFixed(2)).toLocaleString():'')}</div>
                                                </Grid>
                                                
                                                
                                                */}

                                                
                                                
                                                <Grid item xs={12} md={3}>
                                                    <div className='info-record-label'>Escalation :</div>
                                                    <div className='info-record-value'>{infoDetail.escalationpercent} %</div>
                                                </Grid>
                                                
                                                {infoDetail.leasterminateddate && (
                                                 <Grid item xs={12} md={3}>
                                                    <div className='info-record-label'>Terminated Date:</div>
                                                    <div className='info-record-value'>{convert_date(infoDetail.leasterminateddate)}</div>
                                                </Grid>
                                                )}
                                                <Grid item xs={12} md={3}>
                                                    <div className='info-record-label'>Renewal :</div>
                                                    <div className='info-record-value'>{infoDetail.renewalterm}</div>
                                                </Grid>
                                                

                                                <Grid item xs={12} md={12}>
                                                    
                                                            <div className='table-responsive snaptable'>
                                                                <table className='table table-striped'>
                                                                    <thead>
                                                                        <tr>
                                                                        <th className='text-center'>Period</th>
                                                                        <th>Annual Base Rent</th>
                                                                        <th>Monthly Base Rent</th>                                                        
                                                                        <th>Annual Rent CAM</th>
                                                                        <th>Total Annual Rent Base</th>
                                                                        <th>PSF</th>
                                                                        <th>Lease Year</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                       {(() => {
                                                                        const rows = [];
                                                                        let ly = 1;
                                                                        let Mb = 0;
                                                                        const basePSF = infoDetail.rentpersf ?? 0;
                                                                        const sqft = infoDetail.areasf ?? 0;
                                                                        const escalationPercent = infoDetail.escalationpercent ?? 0;

                                                                        const commence = moment(infoDetail.rental_commence_date || infoDetail.commence_date);

                                                                        // Use leasterminateddate if it exists and is earlier than expiration_date
                                                                        let expire = moment(infoDetail.expiration_date);
                                                                        if (infoDetail.leasterminateddate && moment(infoDetail.leasterminateddate).isBefore(expire)) {
                                                                            expire = moment(infoDetail.leasterminateddate);
                                                                        }

                                                                        // // Build anniversary date using commence month/day but in 2023
                                                                        // const minStartYear = 2023;
                                                                        // const anniversary2023 = moment(`${minStartYear}-${commence.format('MM-DD')}`);
                                                                        // const currentStart = commence.year() < 2023 ? anniversary2023.clone() : commence.clone();
                                                                        
                                                                        const currentStart =  commence.clone();

                                                                        let psf = basePSF;
                                                                        const stopDates = (infoDetail.internal_stop_dates ?? []).map(date => moment(date)).sort((a, b) => a - b);

                                                                        let start = currentStart.clone();

                                                                        while (start.isSameOrBefore(expire)) {
                                                                            let nextAnniversaryEnd = start.clone().add(1, 'year').subtract(1, 'day');
                                                                            let end = nextAnniversaryEnd.clone();

                                                                            // If there's an internal stop before expected end
                                                                            const stop = stopDates.find(d => d.isSameOrAfter(start) && d.isSameOrBefore(end));
                                                                            if (stop) {
                                                                            end = stop.clone();
                                                                            }

                                                                            if (end.isAfter(expire)) {
                                                                            end = expire.clone();
                                                                            }

                                                                            Mb = (psf * sqft) / 12;
                                                                            const monthsInPeriod = end.diff(start, 'months') + 1;
                                                                            const annualrentbase = Mb * monthsInPeriod;
                                                                            const annualcam = infoDetail.monthlyrentcam ? infoDetail.monthlyrentcam * monthsInPeriod : 0;
                                                                            const annualother = infoDetail.monthlyrentother ? infoDetail.monthlyrentother * monthsInPeriod : 0;
                                                                            const totalannual = parseFloat((annualrentbase + annualcam + annualother).toFixed(2));

                                                                            rows.push(
                                                                            <tr key={ly}>
                                                                                <td className="info-record-value text-center">
                                                                                {start.format('M/D/YYYY')} - {end.format('M/D/YYYY')}
                                                                                </td>
                                                                                <td className="info-record-value text-center">
                                                                                $ {formatWithTwoDecimals(annualrentbase)}
                                                                                </td>
                                                                                <td className="info-record-value text-center">
                                                                                $ {formatWithTwoDecimals(Mb)}
                                                                                </td>
                                                                                <td className="info-record-value text-center">
                                                                                $ {formatWithTwoDecimals(annualcam)}
                                                                                </td>
                                                                                <td className="info-record-value text-center">
                                                                                $ {formatWithTwoDecimals(totalannual)}
                                                                                </td>
                                                                                <td className="info-record-value text-center">
                                                                                {(Math.floor(psf * 100) / 100).toFixed(2)}
                                                                                </td>
                                                                                <td className="info-record-value text-center">{ly}</td>
                                                                            </tr>
                                                                            );

                                                                            // Escalate PSF if full lease year or stopped by internal stop
                                                                            const isFullYear = end.diff(start, 'months') >= 11;
                                                                            const wasStoppedEarly = stop && stop.isSame(end);
                                                                            if (isFullYear || wasStoppedEarly) {
                                                                            psf *= 1 + escalationPercent / 100;
                                                                            }

                                                                            start = end.clone().add(1, 'day');
                                                                            if (start.isAfter(expire)) break;
                                                                            ly++;
                                                                        }

                                                                        return rows;
                                                                        })()}


                                                                    </tbody>
                                                                    
                                                                </table>

                                                            </div>
                                                            
                                                            
                                                </Grid>
                                                
                                                
                                                </Grid>
                                            
                                        </div>
                                    </div>
                                </Grid>
                                

                                <Grid item xs={12} md={12}>
                                <Tabs
                                    defaultActiveKey={selFY}
                                    // transition={false}
                                    id="justify-tab-example"
                                    className="mb-3 ctab"
                                    
                                    >
                                    {(() => {
                                                        const rows1 =[];
                                                        
                                                        let cdate = moment(infoDetail.rental_commence_date || infoDetail.commence_date);
                                                        let cm = parseInt(cdate.format('MM'));
                                                        let cy = parseInt(cdate.format('YYYY'));
                                                        let edate = moment(infoDetail.leasterminateddate && moment(infoDetail.leasterminateddate).isBefore(moment(infoDetail.expiration_date)) ? infoDetail.leasterminateddate : infoDetail.expiration_date);
                                                        let em = parseInt(edate.format('MM'));
                                                        let ey = parseInt(edate.format('YYYY'));
                                                       
                                                        
                                                        const cud = new Date();
                                                        let cyear = cud.getFullYear();
                                                        let sty = cyear-2;
                                                        const fy2024End = moment.utc((cyear-1)+'-06-30');
                                                        if (cdate.isSameOrBefore(fy2024End)) {
                                                            sty = sty; // FY 2024 starts from 2023
                                                        } else {
                                                            // Otherwise, calculate the fiscal year dynamically
                                                            if (cm >= 7) {
                                                                // July–Dec: lease starts in FY of (cy + 1), base year is cy
                                                                sty = cy;
                                                            } else {
                                                                // Jan–Jun: lease starts in FY of (cy), base year is (cy - 1)
                                                                sty = cy - 1;
                                                            }
                                                        }

                                                        for (let i = sty; i < cyear+4; i++) {
                                                            
                                                            if(i > ey){
                                                                break;

                                                            }else if(i >= ey && 7 > em ){
                                                                break;                                                               

                                                            }
                                                            let endyear = i+1
                                                            let monthlyrentcam = 0
                                                            let monthlyrentother = 0
                                                            let annualrentother = 0
                                                            let annualcam = 0
                                                            const fyValues = getFYBaseRentValues(endyear, infoDetail);
                                                            let cumulativeAnnualBase = 0;

                                                            if(leaseVersions.length > 0){
                                                                // FY period
                                                                const fyStart = moment(`${i}-07-01`);
                                                                const fyEnd = moment(`${endyear}-06-30`);
                                                                // Find all previous versions that overlap this FY
                                                                const overlappingPrevVersions = leaseVersions.filter(v =>
                                                                    v.leaseid !== infoDetail.leaseid && // exclude current
                                                                    moment(v.commence_date).isSameOrBefore(fyEnd) &&
                                                                    moment(v.expiration_date).isSameOrAfter(fyStart)
                                                                );
                                                                // Calculate cumulative from previous versions
                                                                overlappingPrevVersions.forEach(prev => {
                                                                    const prevFYValues = getFYBaseRentValues(endyear, prev);

                                                                    // Add both AB1 + AB2
                                                                    const prevAnnual1 = prevFYValues.monthlyBase1 && prevFYValues.months1? (prevFYValues.monthlyBase1 * prevFYValues.months1).toFixed(2) : 0;
                                                                    const prevAnnual2 = prevFYValues.monthlyBase2 && prevFYValues.months2? (prevFYValues.monthlyBase2 * prevFYValues.months2).toFixed(2) : 0;
                                                                    const prevAnnualcam = prevFYValues.monthlyCam ? (prevFYValues.monthlyCam * ((prevFYValues.months1 ?? 0 ) + (prevFYValues.months2 ?? 0 ) )).toFixed(2) : 0;
                                                                    const prevAnnualOther = prevFYValues.monthlyOther ? (prevFYValues.monthlyOther * ((prevFYValues.months1 ?? 0 ) + (prevFYValues.months2 ?? 0 ) )).toFixed(2) : 0;
                                                                    cumulativeAnnualBase += prevAnnual1 + prevAnnual2 + prevAnnualcam + prevAnnualOther;
                                                                });
                                                            }

                                                            if (Object.keys(fyValues).length === 0) {

                                                            }else{

                                                             const psf1 = fyValues.psf1 ?? 0;
                                                             const psf2 = fyValues.psf2 ?? 0; 
                                                             const months1 = fyValues.months1 ?? 0;
                                                             let months2 = fyValues.months2 ?? 0;   
                                                             let tomonths =   months1+months2                                                        
                                                             let monthlyrentbase1 = fyValues.monthlyBase1 ?? 0;                                                             
                                                             let monthlyrentbase2 = fyValues.monthlyBase2 ?? 0;
                                                             const monthlyAbatement1 = fyValues.monthlyAbatement1 ?? 0;   
                                                             const monthlyAbatement2 = fyValues.monthlyAbatement2 ?? 0; 
                                                             const annualAbatement1 = fyValues.annualAbatement1 ?? 0;   
                                                             const annualAbatement2 = fyValues.annualAbatement2 ?? 0;   
                                                             
                                                            let annualrentbase1 = monthlyrentbase1*months1
                                                            let annualrentbase2 = monthlyrentbase2*months2
                                                            if(tomonths > 12){
                                                                tomonths=12
                                                                months2=months2-1
                                                            }

                                                            
                                                            if(infoDetail.monthlyrentother){
                                                                
                                                                monthlyrentother=infoDetail.monthlyrentother

                                                                annualrentother = infoDetail.monthlyrentother*(tomonths)
                                                            }
                                                            if(infoDetail.monthlyrentcam){

                                                                monthlyrentcam=infoDetail.monthlyrentcam
                                                                
                                                                annualcam = infoDetail.monthlyrentcam*(tomonths)
                                                            }
                                                            if(infoDetail.escalationpercent === 0){

                                                                annualrentbase1 = monthlyrentbase1*(tomonths)

                                                                monthlyrentbase2= 0

                                                                annualrentbase2=0
                                                            }

                                                            


                                                                rows1.push(
                                                                <Tab eventKey={endyear} title={"FY "+endyear}>
                                                                    <Grid container spacing={2}>
                                                                        <Grid item xs={12} md={12}>
                                                                            <div>
                                                                                <div className='info-title'>Annual Rent</div>
                                                                                <div className='info-details'>
                                                                                    <Grid container spacing={2}>                                               
                            
                                                                                        
                                                                                        <Grid item xs={12} md={3}>
                                                                                            <div className='info-record-label'>Annual Rent Base 1 :</div>
                                                                                            <div className='info-record-value'>$ {formatWithTwoDecimals(annualrentbase1)}</div>
                                                                                        </Grid>
                                                                                        
                                                                                        <Grid item xs={12} md={3}>
                                                                                            <div className='info-record-label'>Annual Rent Base 2 :</div>
                                                                                            <div className='info-record-value'>$ {formatWithTwoDecimals(parseFloat(annualrentbase2))}</div>
                                                                                        </Grid>
                            
                                                                                        <Grid item xs={12} md={3}>
                                                                                            <div className='info-record-label'>Annual Rent CAM :</div>
                                                                                            <div className='info-record-value'>$ {formatWithTwoDecimals(parseFloat(annualcam.toFixed(2)))} </div>
                                                                                        </Grid>
                                                                                        
                                                                                        <Grid item xs={12} md={3}>
                                                                                            <div className='info-record-label'>Annual Rent Other :</div>
                                                                                            <div className='info-record-value'>$ {formatWithTwoDecimals(parseFloat(annualrentother.toFixed(2)))}</div>
                                                                                        </Grid>
                                                                                        
                                                                                    </Grid>
                                                                                    
                                                                                </div>
                                                                            </div>
                                                                        </Grid>
                                                                        <Grid item xs={12} md={12}>
                                                                            <div>
                                                                                <div className='info-title'>Month Rent</div>
                                                                                <div className='info-details'>
                                                                                    <Grid container spacing={2}>                                               
                            
                                                                                        
                                                                                        <Grid item xs={12} md={3}>
                                                                                            <div className='info-record-label'>Monthly Rent Base 1 :</div>
                                                                                            <div className='info-record-value'>$ {formatWithTwoDecimals(parseFloat(monthlyrentbase1))}</div>
                                                                                        </Grid>
                                                                                        
                                                                                        <Grid item xs={12} md={3}>
                                                                                            <div className='info-record-label'>Monthly Rent Base 2 :</div>
                                                                                            <div className='info-record-value'>$ {formatWithTwoDecimals(parseFloat(monthlyrentbase2))}</div>
                                                                                        </Grid>
                            
                                                                                        <Grid item xs={12} md={3}>
                                                                                            <div className='info-record-label'>Monthly Rent CAM :</div>
                                                                                            <div className='info-record-value'>$ {formatWithTwoDecimals(parseFloat(monthlyrentcam))}</div>
                                                                                        </Grid>
                                                                                        
                                                                                        <Grid item xs={12} md={3}>
                                                                                            <div className='info-record-label'>Monthly Rent Other :</div>
                                                                                            <div className='info-record-value'>$ {formatWithTwoDecimals(parseFloat(monthlyrentother))}</div>
                                                                                        </Grid>
                                                                                        <Grid item xs={12} md={3}>
                                                                                            <div className='info-record-label'>Rent per SF1 :</div>
                                                                                            <div className='info-record-value'>{(Math.floor(psf1* 100) / 100).toFixed(2)}</div>
                                                                                        </Grid>
                                                                                        {monthlyrentbase2 >  0 && (
                                                                                                <Grid item xs={12} md={3}>
                                                                                                    <div className='info-record-label'>Rent per SF2 :</div>
                                                                                                    <div className='info-record-value'>{(Math.floor(psf2* 100) / 100).toFixed(2)}</div>
                                                                                                </Grid>
                                                                                        )}
                                                                                        
                                                                                        <Grid item xs={12} md={3}>
                                                                                            <div className='info-record-label'>Escalation :</div>
                                                                                            <div className='info-record-value'>{infoDetail.escalationpercent} %</div>
                                                                                        </Grid>
                                                                                        
                                                                                        <Grid item xs={12} md={3}>
                                                                                            <div className='info-record-label'>Non Rent per SF :</div>
                                                                                            <div className='info-record-value'>{infoDetail.nonrentpersf}</div>
                                                                                        </Grid>
                                                                                        
                                                                                    </Grid>
                                                                                    
                                                                                </div>
                                                                            </div>
                                                                        </Grid>
                                                                        
                                                                        <Grid item xs={12} md={6}>
                                                                            <div>
                                                                                <div className='info-title'>Annual Abatement</div>
                                                                                <div className='info-details'>
                                                                                    <Grid container spacing={2}>  
                                                                                        
                                                                                        {annualAbatement1 <  0 && (
                                                                                                <Grid item xs={12} md={6}>
                                                                                                    <div className='info-record-label'>Annual Abatement 1 :</div>
                                                                                                    <div className='info-record-value' style={{color:"#C42929"}}>$ {formatWithTwoDecimals(parseFloat(annualAbatement1))}</div>
                                                                                                </Grid>
                                                                                        )}
                                                                                        {annualAbatement2 <  0 && (
                                                                                                <Grid item xs={12} md={6}>
                                                                                                    <div className='info-record-label'>Annual Abatement 2 :</div>
                                                                                                    <div className='info-record-value' style={{color:"#C42929"}}>$ {formatWithTwoDecimals(parseFloat(annualAbatement2))}</div>
                                                                                                </Grid>
                                                                                        )}
                                                                                        
                                                                                    </Grid>
                                                                                    
                                                                                </div>
                                                                            </div>
                                                                        </Grid>
                                                                        
                                                                        
                                                                        <Grid item xs={12} md={6}>
                                                                            <div>
                                                                                <div className='info-title'>Monthly Abatement</div>
                                                                                <div className='info-details'>
                                                                                    <Grid container spacing={2}>  
                                                                                        
                                                                                        {monthlyAbatement1 <  0 && (
                                                                                                <Grid item xs={12} md={6}>
                                                                                                    <div className='info-record-label'>Monthly Abatement 1 :</div>
                                                                                                    <div className='info-record-value' style={{color:"#C42929"}}>$ {formatWithTwoDecimals(parseFloat(monthlyAbatement1))}</div>
                                                                                                </Grid>
                                                                                        )}
                                                                                        {monthlyAbatement2 <  0 && (
                                                                                                <Grid item xs={12} md={6}>
                                                                                                    <div className='info-record-label'>Monthly Abatement 2 :</div>
                                                                                                    <div className='info-record-value' style={{color:"#C42929"}}>$ {formatWithTwoDecimals(parseFloat(monthlyAbatement2))}</div>
                                                                                                </Grid>
                                                                                        )}
                                                                                        
                                                                                    </Grid>
                                                                                    
                                                                                </div>
                                                                            </div>
                                                                        </Grid>
                                                                        <Grid item xs={12} md={6}>
                                                                            <div>
                                                                                <div className='info-title'>Cumulative Charges</div>
                                                                                <div className='info-details'>
                                                                                    <Grid container spacing={2}>                                               
                            
                                                                                        
                                                                                        <Grid item xs={12} md={6}>
                                                                                            <div className='info-record-label'>Cumulative Charges Base  :</div>
                                                                                            <div className='info-record-value'>$ {formatWithTwoDecimals(parseFloat(annualrentbase1)+parseFloat(cumulativeAnnualBase)+parseFloat(annualrentbase2)+parseFloat(annualcam)+parseFloat(annualrentother))}</div>
                                                                                        </Grid>
                                                                                        
                                                                                        
                                                                                        
                                                                                    </Grid>
                                                                                    
                                                                                </div>
                                                                            </div>
                                                                        </Grid>
                                                                    </Grid>
                                                                </Tab>);
                                                                
                                                                }
                                                            }


                                                        return rows1;
                                                    })()}
                                    
                                    
                                </Tabs>
                                </Grid>
                                
                              

                            </Grid>
                </Box>
            </div>
            </Modal.Body>
            <Modal.Footer>
                {infoDetail.is_active === 'Y' && (
                <Button className="custom-edit-button" onClick={() => editModalopen(infoDetail.leaseid)}>
                    Edit Lease
                </Button>
                )}
                <Button onClick={modClose}>Close</Button>
            </Modal.Footer>
            </Modal>

            <MapModal show={mapModal} onHide={() => setMapModal(false)}  location={location} />

            

            <div className="expandView" style={{display: expandShow}}>
                <a className="expandCl" onClick={expandClose}>&times;</a>
                <div className="expandImg">
                    <img  src={expandImg} alt="Exapnd Image" />
                </div>

            </div>
            <Modal size="lg"  show={dropShow} onHide={dropClose} aria-labelledby="contained-modal-vcenter" centered >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-vcenter">Upload Imgages /Files</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                        
                <div className='loderdiv'>
                    <div className='file-header-label'>Add Property Image (Map Snapshots):</div>
                    <div className='file-image-zone' style={{minHeight:"300px", width:"80%" ,margin:'auto'}}>
                        <Dropzone
                            getUploadParams={getUploadParams}
                            accept="image/*"
                            inputContent={Filezone}
                            />
                    </div>
                    <div className='file-header-label'>Add Property Files (Documents) :</div>
                    <div className='file-doc-zone' style={{minHeight:"200px", width:"80%" ,margin:'auto'}}>
                        <Dropzone
                            getUploadParams={getUploadFiles}
                            accept="*"
                            inputContent={Filezonefile}
                            
                            />
                    </div>
                </div>
                </Modal.Body>
            </Modal>
            
            <Modal size="lg" show={show} scrollable onHide={handleClose}>
                <Modal.Header closeButton>
                <Modal.Title>Add Lease</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                <Autocomplete
                    style={{ width: "80%", margin: "auto", marginBottom: 20 }}
                    freeSolo
                    autoComplete
                    autoHighlight
                    options={buildingsWithProperty}
                    getOptionLabel={(option) => option.label}
                    onChange={handleSelectProperty}
                    renderInput={(params) => (
                        <TextField {...params} label="Search Properties"  focused/>
                    )}
                    />
                    <EmptyItem 
                                colSpan={2}
                            />
                    <form onSubmit={handleSubmit}>
                        <FormControl style={{ margin:'20px' }}>
                            <Box sx={{ flexGrow: 1 }}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} md={6}>
                                        <FormControl variant="filled" fullWidth focused sx={{ m: 1}}>
                                            <InputLabel id="demo-simple-select-standard-label" > Lease Type</InputLabel>
                                            <Select labelId="demo-simple-select-standard-label"  id="leasetype" variant="filled" color="success" focused name="leasetype" label="Lease Type" fullWidth>
                                                <MenuItem disabled value="">
                                                    <em>Select</em>
                                                </MenuItem>
                                                <MenuItem value={"In-Lease"} >In-Lease (Ownership – Non PGCO)</MenuItem>
                                                <MenuItem value={"Out-Lease"} >Out-Lease (Ownership – PGCO)</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    
                                    <Grid item xs={12} md={6}>
                                        <FormControl variant="filled" fullWidth focused sx={{ m: 1}}>
                                            <InputLabel id="demo-simple-select-standard-label2" > Agreement Type</InputLabel>
                                            <Select labelId="demo-simple-select-standard-label2"  id="agreement" variant="filled" color="success" focused name="agreement" label="Agreement Type" fullWidth>
                                                <MenuItem disabled value="">
                                                    <em>Select</em>
                                                </MenuItem>
                                                {agreementOptions.map((option) => (
                                                <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <TextField label="Building ID/L#" name='bid' variant="filled" color="success" focused value={leaseData.bid}  fullWidth inputProps={{ readOnly: true, }}/>
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <TextField label="Property Address" variant="filled" color="success" focused value={leaseData.propertyaddress}  fullWidth inputProps={{ readOnly: true, }}/>
                                    </Grid>
                                    
                                    
                                    <Grid item xs={12} md={6}>
                                        <FormControl fullWidth variant="filled" sx={{ m: 1 }}>
                                            <InputLabel id="suite-multi-label">Select Suites</InputLabel>
                                            <Select
                                                labelId="suite-multi-label"
                                                id="suite-multi"
                                                name="suite-multi"
                                                multiple
                                                value={leaseData.selectedSuites}
                                                onChange={(e) =>
                                                setLeaseData((prev) => ({
                                                    ...prev,
                                                    selectedSuites: e.target.value
                                                }))
                                                }
                                                
                                                renderValue={(selected) =>
                                                selected
                                                    .map((value) => leaseData.suites.find((s) => s.suiteid === value)?.suitenumber)
                                                    .join(", ")
                                                }
                                            >
                                                {leaseData.suites.map((suite) => (
                                                <MenuItem key={suite.suiteid} value={suite.suiteid}>
                                                    <Checkbox checked={leaseData.selectedSuites.indexOf(suite.suiteid) > -1} />
                                                    <ListItemText primary={suite.suitenumber} />
                                                </MenuItem>
                                                ))}
                                            </Select>
                                            </FormControl>


                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <TextField label="Lease Sq. Ft" variant="filled" color="success" focused id="areasf" name="areasf" fullWidth  onChange={(e) =>setLeaseData((prev) => ({ ...prev, areasf: e.target.value }))}/>
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <TextField label="Commence" type="date" variant="filled" color="success" focused  id="commence_date" name="commence_date" fullWidth />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <TextField label="Expiration" type="date" variant="filled" color="success" focused  id="expiration_date" name="expiration_date" fullWidth />
                                    </Grid>  
                                    <Grid item xs={12} md={6}>
                                        <TextField label="Rental Commence Date" type="date" variant="filled" color="success" focused  id="rental_commence_date" name="rental_commence_date" fullWidth />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <TextField label="Rent per SF" variant="filled" color="success" focused  id="rentpersf" name="rentpersf" fullWidth />
                                    </Grid>                            
                                    <Grid item xs={12} md={6}>
                                        <TextField label="Escalation" variant="filled" color="success" focused  id="escalationpercent" name="escalationpercent" fullWidth />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <TextField label="Monthly Rent CAM" variant="filled" color="success" focused  id="monthlyrentcam" name="monthlyrentcam" fullWidth />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <TextField label="Monthly Rent Other" variant="filled" color="success" focused  id="monthlyrentother" name="monthlyrentother" fullWidth />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <TextField label="Agency" variant="filled" color="success" focused  id="agencyname" name="agencyname" fullWidth />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <Autocomplete
                                            freeSolo
                                            autoComplete
                                            autoHighlight
                                            options={tenants.map(t => ({
                                            tenant_id: t.tenant_id,
                                            label: `${t.tenantcontactname} (${t.tenantcontactphone1})`,
                                            name: t.tenantcontactname,
                                            phone1: t.tenantcontactphone1,
                                            phone2: t.tenantcontactphone2,
                                            email1: t.tenantcontactemail1,
                                            email2: t.tenantcontactemail2,
                                            }))}
                                            getOptionLabel={(option) => (typeof option === "string" ? option : option.label)}
                                            onChange={(event, selected) => {
                                            if (!selected) {
                                                setusersData({
                                                ...usersData,
                                                tenant_id: "",
                                                tenantManual: false,
                                                tenantcontactname: "",
                                                tenantcontactphone1: "",
                                                tenantcontactphone2: "",
                                                tenantcontactemail1: "",
                                                tenantcontactemail2: "",
                                                });
                                                return;
                                            }

                                            if (typeof selected === "object") {
                                                // Selected existing tenant
                                                setusersData({
                                                ...usersData,
                                                tenant_id: selected.tenant_id,
                                                tenantManual: false,
                                                tenantcontactname: selected.name,
                                                tenantcontactphone1: selected.phone1,
                                                tenantcontactphone2: selected.phone2,
                                                tenantcontactemail1: selected.email1,
                                                tenantcontactemail2: selected.email2,
                                                });
                                            } else {
                                                // Typed manually
                                                setusersData({
                                                ...usersData,
                                                tenant_id: "",
                                                tenantManual: true,
                                                tenantcontactname: selected,
                                                tenantcontactphone1: "",
                                                tenantcontactphone2: "",
                                                tenantcontactemail1: "",
                                                tenantcontactemail2: "",
                                                });
                                            }
                                            }}
                                            renderInput={(params) => (
                                            <TextField {...params} label="Tenant Contact" focused variant="filled" fullWidth />
                                            )}
                                        />
                                        </Grid>

                                        {/* Contact fields editable for both manual and selected tenants */}
                                        <Grid item xs={12} md={6}>
                                        <TextField
                                            label="Tenant Phone 1"
                                            variant="filled"
                                            fullWidth
                                            color="warning"
                                            focused
                                            value={usersData.tenantcontactphone1 || ""}
                                            onChange={(e) => setusersData({ ...usersData, tenantcontactphone1: e.target.value })}
                                        />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                        <TextField
                                            label="Tenant Phone 2"
                                            variant="filled"
                                            fullWidth
                                            color="warning"
                                            focused
                                            value={usersData.tenantcontactphone2 || ""}
                                            onChange={(e) => setusersData({ ...usersData, tenantcontactphone2: e.target.value })}
                                        />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                        <TextField
                                            label="Tenant Email 1"
                                            variant="filled"
                                            fullWidth
                                            color="warning"
                                            focused
                                            value={usersData.tenantcontactemail1 || ""}
                                            onChange={(e) => setusersData({ ...usersData, tenantcontactemail1: e.target.value })}
                                        />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                        <TextField
                                            label="Tenant Email 2"
                                            variant="filled"
                                            fullWidth
                                            color="warning"
                                            focused
                                            value={usersData.tenantcontactemail2 || ""}
                                            onChange={(e) => setusersData({ ...usersData, tenantcontactemail2: e.target.value })}
                                        />
                                        </Grid>
                                        <Grid item xs={12} md={6}></Grid>

                                        <Grid item xs={12} md={6}>
                                            <Autocomplete
                                            
                                            freeSolo
                                            autoComplete
                                            autoHighlight
                                            options={landlords.map(l => ({
                                                landlord_id: l.landlord_id,
                                                label: `${l.landlordname} (${l.landlordphone1})`,
                                                name: l.landlordname,
                                                phone1: l.landlordphone1,
                                                phone2: l.landlordphone2,
                                                email1: l.landlordemail1,
                                                email2: l.landlordemail2,
                                            }))}
                                            getOptionLabel={(option) => (typeof option === "string" ? option : option.label)}
                                            onChange={(event, selected) => {
                                                if (!selected) {
                                                setusersData({
                                                    ...usersData,
                                                    landlord_id: "",
                                                    landlordManual: false,
                                                    landlordname: "",
                                                    landlordphone1: "",
                                                    landlordphone2: "",
                                                    landlordemail1: "",
                                                    landlordemail2: "",
                                                });
                                                return;
                                                }

                                                // if user selected existing landlord object
                                                if (typeof selected === "object") {
                                                setusersData({
                                                    ...usersData,
                                                    landlord_id: selected.landlord_id,
                                                    landlordManual: false,
                                                    landlordname: selected.name,
                                                    landlordphone1: selected.phone1,
                                                    landlordphone2: selected.phone2,
                                                    landlordemail1: selected.email1,
                                                    landlordemail2: selected.email2,
                                                });
                                                } else {
                                                // typed manually
                                                setusersData({
                                                    ...usersData,
                                                    landlord_id: "",
                                                    landlordManual: true,
                                                    landlordname: selected,
                                                    landlordphone1: "",
                                                    landlordphone2: "",
                                                    landlordemail1: "",
                                                    landlordemail2: "",
                                                });
                                                }
                                            }}
                                            renderInput={(params) => (
                                                <TextField {...params} label="Landlord Contact" focused variant="filled" fullWidth />
                                            )}
                                            />

                                            </Grid>

                                            {/* Contact fields editable for both manual and selected landlords */}
                                            <Grid item xs={12} md={6}>
                                            <TextField
                                                label="Landlord Phone 1"
                                                variant="filled"
                                                fullWidth
                                                color="success"
                                                focused
                                                value={usersData.landlordphone1 || ""}
                                                onChange={(e) =>
                                                setusersData({ ...usersData, landlordphone1: e.target.value })
                                                }
                                            />
                                            </Grid>
                                            <Grid item xs={12} md={6}>
                                            <TextField
                                                label="Landlord Phone 2"
                                                variant="filled"
                                                fullWidth
                                                color="success"
                                                focused
                                                value={usersData.landlordphone2 || ""}
                                                onChange={(e) =>
                                                setusersData({ ...usersData, landlordphone2: e.target.value })
                                                }
                                            />
                                            </Grid>
                                            <Grid item xs={12} md={6}>
                                            <TextField
                                                label="Landlord Email 1"
                                                variant="filled"
                                                fullWidth
                                                color="success"
                                                focused
                                                value={usersData.landlordemail1 || ""}
                                                onChange={(e) =>
                                                setusersData({ ...usersData, landlordemail1: e.target.value })
                                                }
                                            />
                                            </Grid>
                                            <Grid item xs={12} md={6}>
                                            <TextField
                                                label="Landlord Email 2"
                                                variant="filled"
                                                fullWidth
                                                color="success"
                                                focused
                                                value={usersData.landlordemail2 || ""}
                                                onChange={(e) =>
                                                setusersData({ ...usersData, landlordemail2: e.target.value })
                                                }
                                            />
                                            </Grid>

                                    {/* Internal Stop Dates */}
                                    <Grid item xs={12} md={6}>
                                        {internalStopDates.map((date, index) => (
                                            <Box key={`stop-${index}`} display="flex" alignItems="center" mb={1}>
                                                <TextField
                                                    
                                                    label="Internal Stop Dates"
                                                    type="date"
                                                    focused
                                                    variant="filled"
                                                    color="success"
                                                    value={date}
                                                    onChange={(e) => {
                                                        const updated = [...internalStopDates];
                                                        updated[index] = e.target.value;
                                                        setInternalStopDates(updated);
                                                    }}
                                                    fullWidth
                                                />
                                                {index > 0 && (
                                                    <Button onClick={() => {
                                                        const updated = internalStopDates.filter((_, i) => i !== index);
                                                        setInternalStopDates(updated);
                                                    }} style={{ marginLeft: '10px' }} variant="outlined" color="danger" size="small">
                                                        <i className='fa fa-trash'></i>
                                                    </Button>
                                                )}
                                            </Box>
                                        ))}
                                        <Button className='btn ' onClick={() => setInternalStopDates([...internalStopDates, ''])} size="sm" variant="outline-info">
                                           <i className='fa fa-plus'></i>  Add Stop Dates
                                        </Button>
                                    </Grid> 
                                    <Grid item xs={12} md={6}>
                                        <TextField label="Abatement Start" type="date" variant="filled" color="success" focused  id="abatementstart" name="abatementstart" fullWidth />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <TextField label="Abatement End" type="date" variant="filled" color="success" focused  id="abatementend" name="abatementend" fullWidth />
                                    </Grid>  
                                                        
                                    <Grid item xs={12} md={6}>
                                        <TextField label="Renewal" variant="filled" color="success" focused  id="renewalterm" name="renewalterm" fullWidth />
                                    </Grid>   
                                    <Grid item xs={12} md={6}>
                                        <TextField  label="Non Rent per SF" variant="filled" color="success" focused  id="nonrentpersf" name="nonrentpersf" fullWidth />
                                    </Grid>
                                    
                                    <Grid item xs={12} md={6}>
                                        <TextField label="Funding Source" variant="filled" color="success" focused  id="fundingsource" name="fundingsource" fullWidth />
                                    </Grid>
                                    
                                    <Grid item xs={12} md={6}>
                                        <TextField label="Funding Agency" variant="filled" color="success" focused  id="fundingagency" name="fundingagency" fullWidth />
                                    </Grid>
                                    <Grid item xs={12} md={12} style={{ textAlign:'right'}}>
                                        <Button  variant="dark" onClick={handleClose} size="sm" style={{ marginRight:'20px'}}>
                                            Close
                                        </Button>
                                        <Button type="submit" variant="success"  size="sm">
                                            Save
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Box>
                        </FormControl>
                        <input type="hidden" name="buildingid" value={leaseData.buildingid} />
                        <input type="hidden" name="propertyid" value={leaseData.propertyid} />
                    </form>

                </Modal.Body>
            </Modal>


        <Modal id="commentModel" show={commentModal}>
                        <Modal.Header>
                        <Button
                                 variant=""
                                 className="close"
                                 onClick={() => setCommentModal(false)}
                              >
                                 <span>&times;</span>
                                 </Button>
                        </Modal.Header>
                        <Modal.Body role='Document'>
                            <div className='row'></div>
                            <div className='col-xl-12 col-xxl-12 col-lg-12'>
          <div className='card'>
            <div className='card-header border-0 pb-0'>
              <h4 className='card-title col-md-12'>Property Comments:
              {/* <a href="#" className="dx-link dx-link-edit dx-icon-edit dx-link-icon" title="Edit" aria-label="Edit"></a> */}
              </h4>
            </div>
            <div className='card-body'>
              <PerfectScrollbar
                style={{ height: '370px' }}
                id='DZ_W_TimeLine1'
                className='widget-timeline dz-scroll style-1 height370 ps ps--active-y'
              >
                <ul className='timeline'>
                    
                    {
                    
                   Comments.map((comment) => {
                    const color = generateColor();
                    surplusid = comment.leaseid
                    return(
                    
                    <li>
                    <div className='timeline-badge ' style={{color:color}}></div>
                    <div style={{color:color}}
                      className='timeline-panel '
                      
                    >
                      <span>{comment.createdate || (new Date()).toLocaleDateString()}</span>
                      <h6 className='mb-0'>
                        {comment.comment || "No Comments yet"}
                      </h6>
                    </div>
                  </li>)
                  })
                }
                </ul>
                
              </PerfectScrollbar>
            </div>
          </div>
        </div>
                        </Modal.Body>
                        <Modal.Footer style={{justifyContent:'space-between',alignItems:'end'}}>
                            <div>
                            <label>New Comment:</label>
                            <input type='hidden' id="surplusid" value={CommetPID} />
                            <textarea className='form-control' style={{borderColor:'#000'}} ref={newComment} value={null}></textarea>
                            </div>
                        
                
                        <Button className='btn bg-success' onClick={()=> {SaveComment(newComment.current.value, surplusid); newComment.current.value = null;}}>Save</Button>
                        <Button type='button' className='btn ' onClick={()=> setCommentModal(!commentModal)}>Close</Button>
                        </Modal.Footer>
                    </Modal>
                    <Modal size="lg" show={showModalh} onHide={() => setShowModalh(false)}>
                    <Modal.Header closeButton>
                        <Modal.Title>What would you like to do before editing this lease?</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className='text-center'>
                        <div style={{ padding: '1rem 1.5rem', textAlign: 'left', lineHeight: 1.6 }}>
                            <p>You’re about to make changes to this lease. How would you like to proceed?</p>
                            <ol style={{ paddingLeft: '1.25rem' }}>
                            <li>
                                <strong>1. Update the current lease</strong>
                            </li>
                            <li style={{ marginTop: '0.5rem' }}>
                                <strong>2. Create a new lease version (Amendment)</strong><br />
                                <small style={{ color: 'gray' }}>
                                (This keeps the current version in history. You must update the <strong>commence date</strong>.)
                                </small>
                            </li>
                            </ol>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" className='bg-danger' onClick={() => setShowModalh(false)}>Cancel</Button>
                        <Button variant="primary" onClick={handleUpdateExisting}>
                        Update Existing Lease
                        </Button>
                        <Button variant="primary" className='bg-success' onClick={handleCreateNewVersion}>
                        Amendment
                        </Button>
                    </Modal.Footer>
                    </Modal>

                    
                    <Modal show={showDuplicateModal} onHide={() => setShowDuplicateModal(false)}>
                       
                        <Modal.Body className='text-center'>
                            <div style={{ textAlign: 'left', lineHeight: 1.6 }}>
                                <p className="text-black mb-0">
                                Are you sure you want to <b>duplicate</b> this lease?
                                <br />
                                <span className="text-gray-500 text-sm">
                                    Lease No: {selectedLease?.lnumber}
                                </span>
                                </p>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="primary" className='bg-danger' onClick={() => setShowModalh(false)}>Cancel</Button>
                            <Button variant="primary" className='bg-success' onClick={handleDuplicateSubmit}>
                            Duplicate
                            </Button>
                        </Modal.Footer>
                    </Modal>

                    <RenewLeaseModal
                        show={showModal}
                        onClose={() => setShowModal(false)}
                        onSubmit={handleRenewSubmit}
                        lease={selectedLease}
                    />


                    

        </React.Fragment>

            </div>
        </div>
    )
}

export default LeaseDetails;

